<template>
  <div class="pa-mudik-page">
    <section class="pa-mudik-hero">
      <div class="pa-mudik-hero__content">
        <p class="pa-mudik-hero__kicker">PA MUDIK DIGITAL</p>
        <h1 class="pa-mudik-hero__title">
          Proteksi perjalanan lebih cepat, rapi, dan nyaman.
        </h1>
        <p class="pa-mudik-hero__subtitle">
          Isi data peserta, hitung kontribusi otomatis, lalu proses E-Polis
          dalam satu alur.
        </p>
      </div>
      <div class="pa-mudik-hero__chips">
        <span class="pa-mudik-chip"
          ><v-icon small color="secondary">mdi-shield-check-outline</v-icon>
          Aman</span
        >
        <span class="pa-mudik-chip"
          ><v-icon small color="secondary">mdi-lightning-bolt-outline</v-icon>
          Cepat</span
        >
        <span class="pa-mudik-chip"
          ><v-icon small color="secondary"
            >mdi-file-document-check-outline</v-icon
          >
          Paperless</span
        >
      </div>
      <div class="pa-mudik-hero__progress">
        <div class="pa-mudik-hero__progress-label">
          Progress langkah: {{ steppers }} / 4
        </div>
        <v-progress-linear
          :value="steppers * 25"
          height="8"
          rounded
          color="white"
          background-color="rgba(255,255,255,0.25)"
        ></v-progress-linear>
      </div>
    </section>
    <v-container
      v-if="last_register_row && !fastflow_row"
      class="pa-mudik-restore px-0"
    >
      <div class="pa-mudik-restore__card">
        <div>
          <div class="pa-mudik-restore__label">Data Terakhir Tersimpan</div>
          <div class="pa-mudik-restore__value">
            {{ last_register_id || last_register_row }}
          </div>
        </div>
        <v-btn small rounded color="primary" @click="ResumeLastRegister()">
          <v-icon left small>mdi-history</v-icon>
          Lihat Lagi
        </v-btn>
      </div>
    </v-container>
    <v-container class="pa-mudik-restore px-0">
      <div class="pa-mudik-restore__card pa-mudik-restore__card--search">
        <div class="pa-mudik-restore__search-head">
          <div class="pa-mudik-restore__label">Cari Data Register Lama</div>
          <div class="pa-mudik-restore__search-hint">
            Gunakan No Register (contoh: TAC...) atau No KTP.
          </div>
        </div>
        <div class="pa-mudik-restore__search-form">
          <v-text-field
            v-model="search_register_query"
            dense
            outlined
            hide-details
            class="pa-mudik-restore__search-input"
            placeholder="Masukkan No Register / No KTP"
            @keyup.enter="SearchRegisteredData"
          ></v-text-field>
          <v-btn
            rounded
            color="secondary"
            :loading="search_register_loading"
            @click="SearchRegisteredData"
          >
            <v-icon left small>mdi-magnify</v-icon>
            Cari
          </v-btn>
        </div>
      </div>
    </v-container>
    <v-stepper v-model="steppers" class="pa-mudik-stepper elevation-0">
      <v-stepper-header>
        <v-stepper-step :complete="steppers > 1" step="1">Form</v-stepper-step>

        <v-divider></v-divider>

        <v-stepper-step :complete="steppers > 2" step="2"
          >Hitung</v-stepper-step
        >

        <v-divider></v-divider>

        <v-stepper-step :complete="steppers > 3" step="3">Hasil</v-stepper-step>
        <v-divider></v-divider>

        <v-stepper-step step="4">Proses</v-stepper-step>
      </v-stepper-header>

      <v-stepper-items>
        <!-- Step Process -->
        <v-stepper-content step="1" class="pa-mudik-step-content">
          <v-container class="mx-0 px-0 pa-mudik-form-shell">
            <div class="pa-mudik-section-head">
              <p class="pa-mudik-section-head__kicker">Langkah 1 dari 4</p>
              <h2 class="pa-mudik-section-head__title">
                Informasi Dasar Peserta
              </h2>
              <p class="pa-mudik-section-head__subtitle">
                Lengkapi data awal untuk menentukan paket perlindungan
                perjalanan.
              </p>
            </div>
            <v-form
              enctype="multipart/form-data"
              ref="form_quotation_step1"
              lazy-validation
            >
              <v-row class="pa-mudik-step1-grid">
                <v-col cols="12">
                  <div class="pa-mudik-field-label">Paket Proteksi</div>
                  <v-radio-group
                    v-model="quotation_pamudik_package"
                    row
                    class="pa-mudik-package-pills"
                  >
                    <v-radio label="10.000" value="50000000"></v-radio>
                    <v-radio label="20.000" value="100000000"></v-radio>
                    <v-radio label="30.000" value="150000000"></v-radio>
                  </v-radio-group>
                </v-col>

                <v-col cols="12" sm="6" @click="FormSelect('birthdate')">
                  <v-text-field
                    v-model="quotation_pamudik_birthdate_date"
                    style="display:none"
                  ></v-text-field>
                  <v-dialog
                    ref="quotation_pamudik_birthdate_dialog"
                    v-model="quotation_pamudik_birthdate_menu"
                    :return-value.sync="quotation_pamudik_birthdate"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        :value="quotation_pamudik_birthdate_value"
                        label="Tanggal Lahir"
                        :rules="quotation_pamudik_birthdate_rules"
                        @click="quotation_pamudik_birthdate_menu = true"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="quotation_pamudik_birthdate"
                      :max="today"
                      scrollable
                      id="quotation_pamudik_birthdate"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="quotation_pamudik_birthdate_menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="
                          FormSelectChoose(
                            'birthdate',
                            quotation_pamudik_birthdate,
                            quotation_pamudik_birthdate
                          )
                        "
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-col>

                <v-col cols="12" sm="6">
                  <v-text-field
                    v-model="quotation_pamudik_genderid"
                    style="display:none"
                  ></v-text-field>
                  <v-select
                    v-model="quotation_pamudik_genderid"
                    :items="classs"
                    item-text="gendtab_desc"
                    item-value="gendtab_id"
                    label="Jenis Kelamin *"
                    :rules="quotation_pamudik_gender_rules"
                    @change="OnGenderWebChange"
                  ></v-select>
                </v-col>

                <v-col cols="12">
                  <v-text-field
                    v-model="quotation_pamudik_heirs"
                    placeholder="Masukkan Nama Ahli Waris"
                    label="Nama Ahli Waris *"
                    required
                    :rules="quotation_pamudik_heirs_rules"
                    @input="
                      quotation_pamudik_heirs_confirm = quotation_pamudik_heirs
                    "
                  ></v-text-field>
                </v-col>
              </v-row>
            </v-form>
          </v-container>
          <div class="pa-mudik-actions pa-mudik-actions--single">
            <v-btn
              color="primary"
              @click="NextStep(1)"
              block
              rounded
              class="pa-mudik-btn-primary"
            >
              <v-icon left small>mdi-arrow-right</v-icon>
              Lanjut
            </v-btn>
          </div>
        </v-stepper-content>

        <v-stepper-content step="2" class="pa-mudik-step-content">
          <v-container class="mx-0 px-0 pb-0 pa-mudik-form-shell">
            <div class="pa-mudik-section-head">
              <p class="pa-mudik-section-head__kicker">Langkah 2 dari 4</p>
              <h2 class="pa-mudik-section-head__title">
                Periode dan Komponen Proteksi
              </h2>
              <p class="pa-mudik-section-head__subtitle">
                Tentukan periode polis, peserta keluarga tambahan, dan tipe
                perlindungan.
              </p>
            </div>
            <v-form
              enctype="multipart/form-data"
              ref="form_quotation_step2"
              lazy-validation
            >
              <v-layout row wrap class="pa-mudik-grid">
                <v-flex xs12 md5 class="pa-mudik-period-col">
                  <v-dialog
                    ref="quotation_pamudik_inception"
                    v-model="quotation_pamudik_inception_menu"
                    :return-value.sync="quotation_pamudik_inception"
                    persistent
                    lazy
                    full-width
                    width="290px"
                  >
                    <template v-slot:activator="{ on, attrs }">
                      <v-text-field
                        class="pa-mudik-period-input"
                        :value="quotation_pamudik_inception_value"
                        label="Periode Awal"
                        prepend-icon="mdi-calendar-start"
                        :rules="quotation_pamudik_inception_rules"
                        @click="quotation_pamudik_inception_menu = true"
                        readonly
                        v-bind="attrs"
                        v-on="on"
                      ></v-text-field>
                    </template>
                    <v-date-picker
                      v-model="quotation_pamudik_inception"
                      max="2026-03-22"
                      scrollable
                      id="quotation_pamudik_inception"
                    >
                      <v-spacer></v-spacer>
                      <v-btn
                        text
                        color="primary"
                        @click="quotation_pamudik_inception_menu = false"
                        >Cancel</v-btn
                      >
                      <v-btn
                        text
                        color="primary"
                        @click="
                          FormSelectChoose(
                            'inception',
                            quotation_pamudik_inception,
                            quotation_pamudik_inception
                          )
                        "
                        >OK</v-btn
                      >
                    </v-date-picker>
                  </v-dialog>
                </v-flex>
                <v-flex xs12 md5 class="pa-mudik-period-col">
                  <v-text-field
                    class="pa-mudik-period-input"
                    v-model="quotation_pamudik_expiry_value"
                    label="Periode Akhir"
                    prepend-icon="mdi-calendar-end"
                    readonly
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md2 class="pa-mudik-period-day-col">
                  <v-text-field
                    class="pa-mudik-period-day-input"
                    v-model="quotation_pamudik_period"
                    prepend-icon="mdi-calendar-range"
                    placeholder="Hari"
                    label="Periode Hari *"
                    required
                    :rules="quotation_pamudik_period_rules"
                    readonly="readonly"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 md12>
                  <v-text-field
                    v-model="quotation_pamudik_tsi"
                    prepend-icon="mdi-cash-multiple"
                    placeholder="Masukkan Nilai Asuransi"
                    label="Nilai Asuransi *"
                    required
                    :rules="quotation_pamudik_tsi_rules"
                    readonly="readonly"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-btn
                    color="secondary"
                    rounded
                    class="pa-mudik-btn-secondary"
                    @click="AddFamily"
                    >Tambah keluarga
                    <v-icon right dark>mdi-account-multiple-plus</v-icon></v-btn
                  >
                </v-flex>
                <v-flex xs12 md6>
                  <v-radio-group v-model="quotation_pamudik_main" row>
                    <v-radio
                      label="A+B+C+Plus"
                      value="MUDIK"
                      color="secondary"
                    ></v-radio>
                    <v-icon color="secondary" @click="select_information = true"
                      >mdi-help-circle-outline</v-icon
                    >
                  </v-radio-group>
                </v-flex>
                <v-flex xs12 sm12>
                  <v-radio-group v-model="quotation_pamudik_policyflag" row>
                    <!-- <v-radio label="Hardcopy" value="H" color="secondary"></v-radio> -->
                    <v-radio
                      label="E-Polis"
                      value="E"
                      color="secondary"
                    ></v-radio>
                  </v-radio-group>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
          <div class="pa-mudik-actions">
            <v-btn text class="pa-mudik-btn-ghost" @click="steppers = 1">
              <v-icon left small>mdi-arrow-left</v-icon>
              Sebelumnya
            </v-btn>
            <v-btn
              color="primary"
              @click="NextStep(2)"
              rounded
              class="pa-mudik-btn-primary"
            >
              <v-icon left small>mdi-calculator-variant-outline</v-icon>
              Hitung
            </v-btn>
          </div>
          <!-- Dialog Total Sum Insured -->
          <v-dialog v-model="dialog_tsi" hide-overlay fullscreen>
            <v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click="dialog_tsi = false">
                  Batal
                </v-btn>

                <v-btn color="primary" text @click="TSIConfirm">
                  Setuju
                </v-btn>
              </v-card-actions>
              <!-- <v-card-title class="title">Nilai Asuransi</v-card-title> -->
              <v-card-text>
                <v-text-field
                  outline
                  type="tel"
                  label="Nilai di sesuaikan"
                  id="quotation_pamudik_tsi"
                  ref="quotation_pamudik_tsi"
                  v-model.lazy="quotation_pamudik_tsi_confirm"
                  v-money="format_money"
                  @keyup.enter="TSIConfirm"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- Bottom Sheet Year Period -->
          <v-bottom-sheet v-model="select_period">
            <v-list class="pt-0">
              <v-subheader class="primary white--text">Periode</v-subheader>
              <div class="scrollable">
                <v-list-item
                  v-for="period in periods"
                  :key="period.period_id"
                  @click="
                    FormSelectChoose(
                      'period',
                      period.period_id,
                      period.period_id
                    )
                  "
                >
                  <v-list-item-title class="text-xs-center">{{
                    period.period_id
                  }}</v-list-item-title>
                </v-list-item>
              </div>
            </v-list>
          </v-bottom-sheet>
          <!-- Bottom Sheet Year Period -->
          <v-bottom-sheet v-model="select_information">
            <v-list class="pt-0">
              <v-subheader class="info white--text">Informasi</v-subheader>
              <v-list-item
                v-for="information in informations"
                :key="information.information_id"
              >
                <v-list-item-title
                  >{{ information.information_id }}:
                  {{ information.information_desc }}</v-list-item-title
                >
              </v-list-item>
            </v-list>
          </v-bottom-sheet>
        </v-stepper-content>

        <v-stepper-content step="3" class="mx-0 px-0 pa-mudik-step-content">
          <v-container
            class="mx-0 px-0 pa-mudik-form-shell pa-mudik-step3-shell"
          >
            <div class="pa-mudik-section-head pl-3">
              <p class="pa-mudik-section-head__kicker">Langkah 3 dari 4</p>
              <h2 class="pa-mudik-section-head__title">
                Ringkasan Perhitungan
              </h2>
              <p class="pa-mudik-section-head__subtitle">
                Tinjau komponen kontribusi sebelum lanjut ke proses penerbitan
                polis.
              </p>
            </div>
            <div
              class="pa-mudik-total-spotlight pa-mudik-total-spotlight--step3"
            >
              <p class="pa-mudik-total-spotlight__label">
                Estimasi Total Kontribusi
              </p>
              <p class="pa-mudik-total-spotlight__value">
                {{ FormatNumber(fastflowrate_cont_total_min) }}
              </p>
              <p class="pa-mudik-total-spotlight__note">
                Sudah termasuk biaya polis, materai, dan kalkulasi komponen yang
                dipilih.
              </p>
            </div>
            <v-card
              flat
              class="pa-mudik-summary-card pa-mudik-summary-card--step3"
            >
              <v-list class="pa-mudik-breakdown-list">
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-title class="title pa-summary-total-label"
                      >TOTAL</v-list-item-title
                    >
                  </v-list-item-content>
                  <v-list-item-action class="title pa-summary-total-value">
                    {{ FormatNumber(fastflowrate_cont_total_min) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item>
                  <v-list-item-content>
                    <v-list-item-subtitle
                      >{{ MappingDescription(quotation_pamudik_main) }}
                      <small
                        >{{ fastflowrate_min }} %o</small
                      ></v-list-item-subtitle
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_cont_min) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider></v-divider>
                <v-list-item v-if="quotation_pamudik_mate">
                  <v-list-item-content>
                    <v-list-item-subtitle>Istri/Suami</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_mate) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="quotation_pamudik_mate"></v-divider>
                <v-list-item v-if="quotation_pamudik_father">
                  <v-list-item-content>
                    <v-list-item-subtitle>Ayah</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_father) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="quotation_pamudik_father"></v-divider>
                <v-list-item v-if="quotation_pamudik_mother">
                  <v-list-item-content>
                    <v-list-item-subtitle>Ibu</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_mother) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="quotation_pamudik_mother"></v-divider>
                <v-list-item v-if="quotation_pamudik_child1">
                  <v-list-item-content>
                    <v-list-item-subtitle>Anak ke 1</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_child1) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="quotation_pamudik_child1"></v-divider>
                <v-list-item v-if="quotation_pamudik_child2">
                  <v-list-item-content>
                    <v-list-item-subtitle>Anak ke 2</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_child2) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="quotation_pamudik_child2"></v-divider>
                <v-list-item v-if="quotation_pamudik_child3">
                  <v-list-item-content>
                    <v-list-item-subtitle>Anak ke 3</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_child3) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="quotation_pamudik_child3"></v-divider>
                <v-list-item v-if="quotation_pamudik_child4">
                  <v-list-item-content>
                    <v-list-item-subtitle>Anak ke 4</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_child4) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="quotation_pamudik_child4"></v-divider>
                <v-list-item v-if="quotation_pamudik_child5">
                  <v-list-item-content>
                    <v-list-item-subtitle>Anak ke 5</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_child5) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="quotation_pamudik_child5"></v-divider>
                <v-list-item v-if="fastflowrate_discount">
                  <v-list-item-content>
                    <v-list-item-subtitle>POTONGAN</v-list-item-subtitle>
                  </v-list-item-content>
                  <v-list-item-action>
                    - {{ FormatNumber(fastflowrate_discount) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="fastflowrate_discount"></v-divider>
                <v-list-item v-if="fastflowrate_feeduty">
                  <v-list-item-content>
                    <v-list-item-subtitle
                      >BIAYA POLIS &amp; MATERAI</v-list-item-subtitle
                    >
                  </v-list-item-content>
                  <v-list-item-action>
                    {{ FormatNumber(fastflowrate_feeduty) }}
                  </v-list-item-action>
                </v-list-item>
                <v-divider v-if="fastflowrate_feeduty"></v-divider>
              </v-list>
            </v-card>
            <div class="pa-mudik-actions pa-mudik-actions--step3">
              <v-btn text class="pa-mudik-btn-ghost" @click="steppers = 2">
                <v-icon left small>mdi-arrow-left</v-icon>
                Sebelumnya
              </v-btn>
              <v-btn
                color="primary"
                @click="steppers = 4"
                rounded
                class="pa-mudik-btn-primary"
              >
                <v-icon left small>mdi-arrow-right</v-icon>
                Lanjut
              </v-btn>
            </div>
          </v-container>
        </v-stepper-content>
        <!-- Finalized Process -->
        <v-stepper-content step="4" class="pa-mudik-step-content">
          <v-container
            class="mx-0 px-0 pb-0 pa-mudik-form-shell pa-mudik-step4-shell"
          >
            <div class="pa-mudik-section-head">
              <p class="pa-mudik-section-head__kicker">Langkah 4 dari 4</p>
              <h2 class="pa-mudik-section-head__title">
                Data Final dan Penerbitan E-Polis
              </h2>
              <p class="pa-mudik-section-head__subtitle">
                Pastikan data kontak dan identitas sudah sesuai sebelum proses
                cover note.
              </p>
            </div>
            <v-form
              enctype="multipart/form-data"
              ref="form_quotation_step3"
              lazy-validation
            >
              <v-layout row wrap class="pa-mudik-grid">
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="quotation_pamudik_idno"
                    prepend-icon="mdi-card-account-details-outline"
                    placeholder="Masukkan Nomor KTP"
                    label="Nomor KTP *"
                    required
                    :rules="quotation_pamudik_idno_rules"
                    @input="
                      quotation_pamudik_idno_confirm = quotation_pamudik_idno
                    "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="quotation_pamudik_insured"
                    prepend-icon="mdi-account-outline"
                    placeholder="Masukkan Nama Peserta"
                    label="Nama Peserta *"
                    required
                    :rules="quotation_pamudik_insured_rules"
                    @input="
                      quotation_pamudik_insured_confirm =
                        quotation_pamudik_insured
                    "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6 v-if="quotation_pamudik_sourceflag">
                  <v-text-field
                    v-model="quotation_pamudik_sourceid"
                    style="display:none"
                  ></v-text-field>
                  <v-text-field
                    v-model="quotation_pamudik_sourcedesc"
                    prepend-icon="mdi-account-tie-outline"
                    placeholder="Masukkan Nama Agen"
                    label="Nama Agen (jika ada)"
                  ></v-text-field>
                  <v-text-field
                    v-model="quotation_pamudik_sourceujroh"
                    style="display:none"
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="quotation_pamudik_phone"
                    prepend-icon="mdi-cellphone"
                    placeholder="Masukkan Nomor HP Peserta"
                    label="Nomor HP Peserta *"
                    required
                    :rules="quotation_pamudik_phone_rules"
                    @input="
                      quotation_pamudik_phone_confirm = quotation_pamudik_phone
                    "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm6>
                  <v-text-field
                    v-model="quotation_pamudik_email"
                    prepend-icon="mdi-email-outline"
                    placeholder="Masukkan Email Peserta"
                    label="Email Peserta *"
                    required
                    :rules="quotation_pamudik_email_rules"
                    @input="
                      quotation_pamudik_email_confirm = quotation_pamudik_email
                    "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm8>
                  <v-text-field
                    v-model="quotation_pamudik_address"
                    prepend-icon="mdi-map-marker-outline"
                    placeholder="Masukkan Alamat Peserta"
                    label="Alamat Peserta *"
                    required
                    :rules="quotation_pamudik_address_rules"
                    @input="
                      quotation_pamudik_address_confirm =
                        quotation_pamudik_address
                    "
                  ></v-text-field>
                </v-flex>
                <v-flex xs12 sm12 md4>
                  <v-text-field
                    v-model="quotation_pamudik_zipcode"
                    prepend-icon="mdi-mailbox-outline"
                    placeholder="Masukkan Kode Pos Peserta"
                    label="Kode Pos Peserta *"
                    @input="
                      quotation_pamudik_zipcode_confirm =
                        quotation_pamudik_zipcode
                    "
                  ></v-text-field>
                </v-flex>
              </v-layout>
            </v-form>
          </v-container>
          <div class="pa-mudik-actions">
            <v-btn text class="pa-mudik-btn-ghost" @click="steppers = 3">
              <v-icon left small>mdi-arrow-left</v-icon>
              Sebelumnya
            </v-btn>
            <v-btn
              :color="IsRegisterLocked() ? 'grey lighten-1' : 'secondary'"
              :disabled="IsRegisterLocked()"
              @click="ConfirmData()"
              rounded
              class="pa-mudik-btn-accent"
            >
              <v-icon left small>
                {{
                  IsRegisterLocked()
                    ? "mdi-check-decagram"
                    : "mdi-shield-check-outline"
                }}
              </v-icon>
              {{ IsRegisterLocked() ? "Sudah Register" : "Register" }}
            </v-btn>
            <v-btn
              v-if="payment_ready"
              color="primary"
              text
              :loading="payment_checking"
              class="pa-mudik-btn-ghost"
              @click="CheckPaymentStatus(false, true)"
            >
              <v-icon left small>mdi-cash-check</v-icon>
              Cek Pembayaran
            </v-btn>
          </div>
          <div v-if="payment_ready" class="pa-va-ramadan mt-4">
            <div class="pa-va-ramadan__header">
              <div>
                <p class="pa-va-ramadan__badge">Ramadan 1447 H</p>
                <h3 class="pa-va-ramadan__title">Virtual Account Pembayaran</h3>
              </div>
              <div class="pa-va-ramadan__register">
                No Register: <strong>{{ payment_fastflow_id || "-" }}</strong>
              </div>
            </div>

            <div class="pa-va-ramadan__list">
              <div class="pa-va-ramadan__item">
                <div class="pa-va-ramadan__item-top">
                  <span class="pa-va-ramadan__bank">
                    <v-icon small color="#0b766f">mdi-bank</v-icon>
                    BMI
                  </span>
                  <span class="pa-va-ramadan__hint"
                    >Transfer Virtual Account</span
                  >
                </div>
                <div class="pa-va-ramadan__number">
                  {{ payment_va_bmi || "-" }}
                </div>
                <v-btn
                  small
                  class="pa-va-ramadan__copy-btn"
                  :disabled="!payment_va_bmi"
                  @click="CopyVirtualAccount('BMI', payment_va_bmi)"
                >
                  <v-icon left small>mdi-content-copy</v-icon>
                  Copy VA BMI
                </v-btn>
              </div>

              <div class="pa-va-ramadan__item">
                <div class="pa-va-ramadan__item-top">
                  <span class="pa-va-ramadan__bank">
                    <v-icon small color="#0b766f">mdi-bank</v-icon>
                    BCA
                  </span>
                  <span class="pa-va-ramadan__hint"
                    >Transfer Virtual Account</span
                  >
                </div>
                <div class="pa-va-ramadan__number">
                  {{ payment_va_bca || "-" }}
                </div>
                <v-btn
                  small
                  class="pa-va-ramadan__copy-btn"
                  :disabled="!payment_va_bca"
                  @click="CopyVirtualAccount('BCA', payment_va_bca)"
                >
                  <v-icon left small>mdi-content-copy</v-icon>
                  Copy VA BCA
                </v-btn>
              </div>
            </div>

            <div class="pa-va-ramadan__footer">
              <div class="pa-va-ramadan__status">
                Status:
                <strong>{{
                  payment_status_desc ||
                    payment_fastflow_status ||
                    "Menunggu pembayaran"
                }}</strong>
              </div>
              <div class="pa-va-ramadan__note">
                Policy akan muncul otomatis setelah pembayaran tervalidasi.
              </div>
            </div>
          </div>
          <!-- Show only Status is still Request -->
          <!-- Dialog Insured Name -->
          <v-dialog v-model="dialog_insured" hide-overlay fullscreen>
            <v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- Name Insured -->
                <v-btn color="secondary" text @click="dialog_insured = false">
                  Batal
                </v-btn>

                <v-btn
                  color="primary"
                  text
                  @click="FormSelectChoose('insured', '', '')"
                >
                  Ok
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <!-- <v-card-title class="title">Nama Peserta</v-card-title> -->
                <v-text-field
                  outline
                  clearable
                  label="Nama Peserta"
                  id="quotation_pamudik_insured"
                  ref="quotation_pamudik_insured"
                  v-model="quotation_pamudik_insured_confirm"
                  @keyup.enter="FormSelectChoose('insured', '', '')"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- Dialog Agen -->
          <v-dialog v-model="select_agen" hide-overlay fullscreen>
            <v-card>
              <v-layout>
                <v-flex xs12 sm12>
                  <v-card flat>
                    <v-card-actions>
                      <v-spacer></v-spacer>
                      <v-btn
                        color="secondary"
                        text
                        @click="select_agen = false"
                      >
                        Batal
                      </v-btn>
                    </v-card-actions>
                    <v-text-field
                      box
                      v-model="select_agen_search"
                      clearable
                      placeholder="Cari berdasarkan ID / Nama"
                      id="select_agen_search"
                      append-icon="mdi-magnify"
                      required
                      :rules="select_agen_search_rules"
                      @keyup.enter="SearchData"
                      @click:append="SearchData"
                    ></v-text-field>
                    <v-progress-linear
                      indeterminate
                      color="primary"
                      v-if="loading_agen"
                    ></v-progress-linear>
                    <v-list two-line class="pt-0">
                      <span v-if="agens.length > 0">
                        <template v-for="(agen, $index) in agens">
                          <v-list-item
                            :key="agen.careprofile_id"
                            :data-num="$index + 1"
                            ripple
                          >
                            <v-list-item-content
                              @click="
                                FormSelectChoose(
                                  'agen',
                                  agen.careprofile_id,
                                  agen.careprofile_name
                                )
                              "
                            >
                              <v-list-item-title
                                >{{ agen.careprofile_id }}
                                {{ agen.careprofile_name }}</v-list-item-title
                              >
                            </v-list-item-content>
                            <v-list-item-action> </v-list-item-action>
                          </v-list-item>
                          <v-divider
                            v-if="$index + 1 < agen.length"
                            :key="$index"
                          ></v-divider>
                        </template>
                      </span>
                    </v-list>
                  </v-card>
                </v-flex>
              </v-layout>
            </v-card>
          </v-dialog>
          <!-- Dialog Phone -->
          <v-dialog v-model="dialog_phone" hide-overlay fullscreen>
            <v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click="dialog_phone = false">
                  Batal
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="FormSelectChoose('phone', '', '')"
                >
                  Ok
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <!-- <v-card-title class="title">Nomor HP Peserta</v-card-title> -->
                <v-text-field
                  outline
                  clearable
                  type="tel"
                  label="Masukkan nomor HP valid"
                  id="quotation_pamudik_phone"
                  ref="quotation_pamudik_phone"
                  v-model="quotation_pamudik_phone_confirm"
                  @keyup.enter="FormSelectChoose('phone', '', '')"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- Dialog Email -->
          <v-dialog v-model="dialog_email" hide-overlay fullscreen>
            <v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <v-btn color="secondary" text @click="dialog_email = false">
                  Batal
                </v-btn>
                <v-btn
                  color="primary"
                  text
                  @click="FormSelectChoose('email', '', '')"
                >
                  Ok
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <!-- <v-card-title class="title">Email Peserta</v-card-title> -->
                <v-text-field
                  outline
                  clearable
                  label="Masukkan email valid"
                  id="quotation_pamudik_email"
                  ref="quotation_pamudik_email"
                  v-model="quotation_pamudik_email_confirm"
                  @keyup.enter="FormSelectChoose('email', '', '')"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- Dialog Insured Address -->
          <v-dialog v-model="dialog_address" hide-overlay fullscreen>
            <v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- Address -->
                <v-btn color="secondary" text @click="dialog_address = false">
                  Batal
                </v-btn>

                <v-btn
                  color="primary"
                  text
                  @click="FormSelectChoose('address', '', '')"
                >
                  Ok
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <!-- <v-card-title class="title">Alamat Peserta</v-card-title> -->
                <v-textarea
                  outline
                  clearable
                  label="Alamat Peserta"
                  id="quotation_pamudik_address"
                  v-model="quotation_pamudik_address_confirm"
                  @keyup.enter="FormSelectChoose('address', '', '')"
                ></v-textarea>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- Dialog Zip Code -->
          <v-dialog v-model="dialog_zipcode" hide-overlay fullscreen>
            <v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- Zip Code -->
                <v-btn color="secondary" text @click="dialog_zipcode = false">
                  Batal
                </v-btn>

                <v-btn
                  color="primary"
                  text
                  @click="FormSelectChoose('zipcode', '', '')"
                >
                  Ok
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <!-- <v-card-title class="title">Kode Pos Peserta</v-card-title> -->
                <v-text-field
                  outline
                  clearable
                  label="Kode Pos Peserta"
                  id="quotation_pamudik_zipcode"
                  v-model="quotation_pamudik_zipcode_confirm"
                  @keyup.enter="FormSelectChoose('zipcode', '', '')"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-dialog>
          <!-- Dialog ID No -->
          <v-dialog v-model="dialog_idno" hide-overlay fullscreen>
            <v-card>
              <v-card-actions>
                <v-spacer></v-spacer>
                <!-- Heirs -->
                <v-btn color="secondary" text @click="dialog_idno = false">
                  Batal
                </v-btn>

                <v-btn
                  color="primary"
                  text
                  @click="FormSelectChoose('idno', '', '')"
                >
                  Ok
                </v-btn>
              </v-card-actions>
              <v-card-text>
                <v-text-field
                  outline
                  clearable
                  type="tel"
                  label="Nomor KTP"
                  id="quotation_pamudik_idno"
                  v-model="quotation_pamudik_idno_confirm"
                  @keyup.enter="FormSelectChoose('idno', '', '')"
                ></v-text-field>
              </v-card-text>
            </v-card>
          </v-dialog>
        </v-stepper-content>
      </v-stepper-items>
    </v-stepper>
    <v-dialog v-model="dialog_confirm" max-width="490">
      <v-card>
        <v-card-title class="primary headline white--text">{{
          title_confirm
        }}</v-card-title>
        <v-card-text> </v-card-text>
        <v-card-actions>
          <v-spacer></v-spacer>
          <v-btn color="secondary" text @click.stop="dialog_confirm = false"
            >Cancel</v-btn
          >
          <v-btn
            id="dialog_confirm_true"
            color="primary"
            text
            @click="ProcessData"
            >Ok</v-btn
          >
        </v-card-actions>
      </v-card>
    </v-dialog>
    <!-- Dialog Total Sum Insured -->
    <v-dialog
      v-model="dialog_family"
      max-width="860"
      persistent
      scrollable
      content-class="pa-family-dialog-wrap"
    >
      <v-card class="pa-family-dialog">
        <div class="pa-family-dialog__top">
          <div>
            <p class="pa-family-dialog__kicker">Data Keluarga</p>
            <h3 class="pa-family-dialog__title">Tambahkan Peserta Keluarga</h3>
            <p class="pa-family-dialog__subtitle">
              Opsional. Isi hanya anggota keluarga yang ingin dilindungi.
            </p>
          </div>
          <v-btn
            icon
            class="pa-family-dialog__close"
            @click="dialog_family = false"
          >
            <v-icon>mdi-close</v-icon>
          </v-btn>
        </div>
        <v-card-text class="pa-family-dialog__body">
          <v-row dense>
            <v-col cols="12" md="6">
              <v-text-field
                id="quotation_pamudik_mate"
                v-model="quotation_pamudik_mate"
                outlined
                dense
                clearable
                label="Nama Istri/Suami"
                prepend-inner-icon="mdi-heart-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                id="quotation_pamudik_father"
                v-model="quotation_pamudik_father"
                outlined
                dense
                clearable
                label="Nama Ayah"
                prepend-inner-icon="mdi-account-tie-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                id="quotation_pamudik_mother"
                v-model="quotation_pamudik_mother"
                outlined
                dense
                clearable
                label="Nama Ibu"
                prepend-inner-icon="mdi-face-woman-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="quotation_pamudik_child1"
                outlined
                dense
                clearable
                label="Nama Anak ke 1"
                prepend-inner-icon="mdi-baby-face-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="quotation_pamudik_child2"
                outlined
                dense
                clearable
                label="Nama Anak ke 2"
                prepend-inner-icon="mdi-baby-face-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="quotation_pamudik_child3"
                outlined
                dense
                clearable
                label="Nama Anak ke 3"
                prepend-inner-icon="mdi-baby-face-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="quotation_pamudik_child4"
                outlined
                dense
                clearable
                label="Nama Anak ke 4"
                prepend-inner-icon="mdi-baby-face-outline"
              ></v-text-field>
            </v-col>
            <v-col cols="12" md="6">
              <v-text-field
                v-model="quotation_pamudik_child5"
                outlined
                dense
                clearable
                label="Nama Anak ke 5"
                prepend-inner-icon="mdi-baby-face-outline"
              ></v-text-field>
            </v-col>
          </v-row>
        </v-card-text>
        <v-card-actions class="pa-family-dialog__actions">
          <v-btn text color="grey darken-1" @click="CancelFamily">Reset</v-btn>
          <v-spacer></v-spacer>
          <v-btn text color="secondary" @click="dialog_family = false"
            >Tutup</v-btn
          >
          <v-btn color="primary" rounded @click="dialog_family = false">
            <v-icon left small>mdi-check</v-icon>
            Simpan
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-dialog
      v-model="dialog_payment_info"
      max-width="760"
      content-class="pa-payment-dialog-wrap"
    >
      <v-card class="pa-payment-dialog">
        <div
          class="pa-payment-dialog__top"
          :class="{ 'pa-payment-dialog__top--paid': payment_dialog_paid }"
        >
          <div class="pa-payment-dialog__hero">
            <div class="pa-payment-dialog__icon">
              <v-icon color="#ffffff" size="22">
                {{
                  payment_dialog_paid ? "mdi-check-decagram" : "mdi-cash-clock"
                }}
              </v-icon>
            </div>
            <div>
              <p class="pa-payment-dialog__kicker">
                {{
                  payment_dialog_paid
                    ? "Pembayaran Tervalidasi"
                    : "Status Pembayaran"
                }}
              </p>
              <h3 class="pa-payment-dialog__title">
                {{
                  payment_dialog_paid
                    ? "Policy Siap Diproses"
                    : "Menunggu Pembayaran VA"
                }}
              </h3>
            </div>
          </div>
          <v-chip
            small
            label
            class="pa-payment-dialog__status-chip"
            text-color="#ffffff"
            :color="payment_dialog_paid ? 'success' : 'orange darken-2'"
          >
            {{ payment_status_desc || payment_fastflow_status || "PENDING" }}
          </v-chip>
        </div>
        <v-card-text class="pa-payment-dialog__body">
          <div class="pa-payment-dialog__register">
            No Register: <strong>{{ payment_fastflow_id || "-" }}</strong>
          </div>
          <div class="pa-payment-dialog__steps">
            <div class="pa-payment-dialog__step pa-payment-dialog__step--done">
              <span class="pa-payment-dialog__step-dot">1</span>
              Register
            </div>
            <div
              class="pa-payment-dialog__step"
              :class="{
                'pa-payment-dialog__step--done': payment_dialog_paid,
                'pa-payment-dialog__step--active': !payment_dialog_paid
              }"
            >
              <span class="pa-payment-dialog__step-dot">2</span>
              Pembayaran
            </div>
            <div
              class="pa-payment-dialog__step"
              :class="{ 'pa-payment-dialog__step--done': payment_dialog_paid }"
            >
              <span class="pa-payment-dialog__step-dot">3</span>
              Policy
            </div>
          </div>
          <div class="pa-payment-dialog__grid">
            <div class="pa-payment-dialog__item">
              <div class="pa-payment-dialog__item-label">VA BMI</div>
              <div class="pa-payment-dialog__item-number">
                {{ payment_va_bmi || "-" }}
              </div>
              <v-btn
                small
                class="pa-payment-dialog__copy"
                :disabled="!payment_va_bmi"
                @click="CopyVirtualAccount('BMI', payment_va_bmi)"
              >
                <v-icon left small>mdi-content-copy</v-icon>
                Copy BMI
              </v-btn>
            </div>
            <div class="pa-payment-dialog__item">
              <div class="pa-payment-dialog__item-label">VA BCA</div>
              <div class="pa-payment-dialog__item-number">
                {{ payment_va_bca || "-" }}
              </div>
              <v-btn
                small
                class="pa-payment-dialog__copy"
                :disabled="!payment_va_bca"
                @click="CopyVirtualAccount('BCA', payment_va_bca)"
              >
                <v-icon left small>mdi-content-copy</v-icon>
                Copy BCA
              </v-btn>
            </div>
          </div>
          <div class="pa-payment-dialog__note">
            {{
              payment_dialog_paid
                ? "Pembayaran sudah tervalidasi. Policy sudah terbayar dan bisa dicetak."
                : "Silakan lakukan pembayaran ke salah satu VA di atas. Policy akan muncul otomatis setelah tervalidasi."
            }}
          </div>
        </v-card-text>
        <v-card-actions class="pa-payment-dialog__actions">
          <v-spacer></v-spacer>
          <v-btn
            text
            color="grey darken-1"
            @click="dialog_payment_info = false"
          >
            Tutup
          </v-btn>
          <v-btn
            v-if="payment_dialog_paid"
            color="primary"
            rounded
            @click="
              dialog_payment_info = false;
              OpenPolicyAfterPayment();
            "
          >
            Lihat Policy
          </v-btn>
        </v-card-actions>
      </v-card>
    </v-dialog>
    <v-overlay
      :value="dialog_loading"
      opacity="0.28"
      z-index="2500"
      class="pa-mudik-loader-overlay"
    >
      <div class="pa-mudik-loader-card" role="status" aria-live="polite">
        <div class="pa-mudik-loader-head">
          <div class="pa-mudik-loader-ring">
            <span class="pa-mudik-loader-ring__core"></span>
          </div>
          <div class="pa-mudik-loader-copy">
            <p class="pa-mudik-loader-title">{{ loading_title }}</p>
            <p class="pa-mudik-loader-subtitle">{{ loading_subtitle }}</p>
          </div>
        </div>
        <div class="pa-mudik-loader-track">
          <span class="pa-mudik-loader-glow"></span>
        </div>
      </div>
    </v-overlay>
    <app-dialognotification
      :visible="dialog_notification"
      :text="dialog_notification_text"
      :flag="dialog_notification_flag"
      @close="dialog_notification = false"
    />
    <v-snackbar :timeout="snackbar_timeout" v-model="snackbar_dialog">
      {{ snackbar_text }}
    </v-snackbar>
  </div>
</template>
<script>
export default {
  data: () => ({
    steppers: 1,
    today: new Date().toISOString().substr(0, 10),
    currentyear: new Date().getFullYear(),
    //Dialog  Loading
    dialog_confirm: false,
    dialog_loading: false,
    loading_title: "Memproses Data",
    loading_subtitle: "Mohon tunggu sebentar...",
    dialog_notification: false,
    dialog_notification_text: "",
    dialog_notification_flag: false,
    title_confirm: "",
    //Format Number
    format_money: {
      decimal: ",",
      thousands: ".",
      precision: 0
    },
    url_type: "add",
    fastflow_row: "",
    fastflow_status: "",
    fastflow_confirm: "",
    payment_ready: false,
    payment_checking: false,
    payment_fastflow_row: "",
    payment_fastflow_id: "",
    payment_fastflow_status: "",
    payment_status_desc: "",
    payment_epolicy_url: "",
    payment_va_bmi: "",
    payment_va_bca: "",
    payment_paidby: "",
    payment_paiddate: "",
    payment_paidrefno: "",
    payment_trx_id: "",
    dialog_payment_info: false,
    payment_dialog_paid: false,
    last_register_row: "",
    last_register_id: "",
    search_register_query: "",
    search_register_loading: false,
    //BirthDate
    quotation_pamudik_birthdate: new Date().toISOString().substr(0, 10),
    quotation_pamudik_birthdate_menu: false,
    quotation_pamudik_birthdate_date: new Date().toISOString().substr(0, 10),
    quotation_pamudik_birthdate_rules: [
      v => !!v || "Mohon masukkan Tanggal Lahir"
    ],
    //Class
    classs: [],
    select_gender: false,
    quotation_pamudik_genderid: "",
    quotation_pamudik_genderdesc: "",
    quotation_pamudik_gender_rules: [v => !!v || "Mohon pilih Gender"],
    //TSI
    dialog_tsi: false,
    quotation_pamudik_tsi: 0,
    quotation_pamudik_addtsi: 0,
    quotation_pamudik_tsi_old: 0,
    quotation_pamudik_tsi_confirm: 0,
    quotation_pamudik_tsi_min: 0,
    quotation_pamudik_tsi_max: 0,
    quotation_pamudik_tsi_rules: [v => !!v || "Mohon isi TSI"],
    //Period
    periods: [],
    select_period: false,
    quotation_pamudik_period: 14,
    quotation_pamudik_period_rules: [v => !!v || "Mohon pilih periode hari"],
    quotation_pamudik_main: "MUDIK",
    //Information
    select_information: false,
    informations: [],
    //RESULT
    results: [],
    fastflowrate_min: 0,
    fastflowrate_cont_min: 0,
    fastflowrate_cont_max: 0,
    fastflowrate_cont_total_min: 0,
    fastflowrate_cont_total_max: 0,
    fastflowrate_feeduty: 0,
    fastflowrate_discount: 0,
    fastflowrate_mate: 0,
    fastflowrate_father: 0,
    fastflowrate_mother: 0,
    fastflowrate_child1: 0,
    fastflowrate_child2: 0,
    fastflowrate_child3: 0,
    fastflowrate_child4: 0,
    fastflowrate_child5: 0,
    //Insured
    dialog_insured: false,
    quotation_pamudik_insured: "",
    quotation_pamudik_insured_confirm: "",
    quotation_pamudik_insured_rules: [v => !!v || "Mohon pilih nama Peserta"],
    quotation_pamudik_policyflag: "E",
    //ID No
    dialog_idno: false,
    quotation_pamudik_idno: "",
    quotation_pamudik_idno_confirm: "",
    quotation_pamudik_idno_rules: [v => !!v || "Mohon masukkan nomor KTP"],
    //Agen
    loading_agen: false,
    select_agen: false,
    select_agen_search: "",
    select_agen_search_rules: [v => !!v || "Mohon isi ID / Nama Agen"],
    agens: [],
    quotation_pamudik_sourceflag: true,
    quotation_pamudik_sourceid: "",
    quotation_pamudik_sourcedesc: "",
    quotation_pamudik_sourceujroh: 0,
    //Phone
    dialog_phone: false,
    quotation_pamudik_phone: "",
    quotation_pamudik_phone_confirm: "",
    quotation_pamudik_phone_rules: [v => !!v || "Mohon masukkan nomor HP"],
    //Email
    dialog_email: false,
    quotation_pamudik_email: "",
    quotation_pamudik_email_confirm: "",
    quotation_pamudik_email_rules: [
      v => !!v || "Mohon masukkan email",
      v => /.+@.+/.test(v) || "Email harus valid"
    ],
    //Address
    dialog_address: false,
    quotation_pamudik_address: "",
    quotation_pamudik_address_confirm: "",
    quotation_pamudik_address_rules: [v => !!v || "Mohon masukkan alamat"],
    //Zipcode
    dialog_zipcode: false,
    quotation_pamudik_zipcode: "",
    quotation_pamudik_zipcode_confirm: "",
    //Heirs
    quotation_pamudik_heirs: "",
    quotation_pamudik_heirs_confirm: "",
    quotation_pamudik_heirs_rules: [v => !!v || "Mohon isi nama Ahli Waris"],
    quotation_pamudik_package: "50000000",
    dialog_family: false,
    quotation_pamudik_mate: "",
    quotation_pamudik_father: "",
    quotation_pamudik_mother: "",
    quotation_pamudik_child1: "",
    quotation_pamudik_child2: "",
    quotation_pamudik_child3: "",
    quotation_pamudik_child4: "",
    quotation_pamudik_child5: "",
    snackbar_dialog: false,
    snackbar_text: "",
    snackbar_timeout: 3000,
    quotation_pamudik_inception: new Date().toISOString().substr(0, 10),
    quotation_pamudik_inception_menu: false,
    quotation_pamudik_inception_date: new Date().toISOString().substr(0, 10),
    quotation_pamudik_inception_rules: [
      v => !!v || "Mohon masukkan Tanggal Awal"
    ],
    quotation_pamudik_expiry: new Date(
      new Date().setDate(new Date().getDate() + 14)
    )
      .toISOString()
      .substr(0, 10),
    quotation_pamudik_expiry_date: new Date(
      new Date().setDate(new Date().getDate() + 14)
    )
      .toISOString()
      .substr(0, 10)
  }),
  computed: {
    quotation_pamudik_birthdate_value() {
      return this.quotation_pamudik_birthdate
        ? this.$moment(this.quotation_pamudik_birthdate).format("LL")
        : "";
    },
    quotation_pamudik_inception_value() {
      return this.quotation_pamudik_inception
        ? this.$moment(this.quotation_pamudik_inception).format("LL")
        : "";
    },
    quotation_pamudik_expiry_value() {
      return this.quotation_pamudik_expiry
        ? this.$moment(this.quotation_pamudik_expiry).format("LL")
        : "";
    }
  },
  // Check If Back Button Press, Modal Close
  beforeRouteLeave(to, from, next) {
    if (
      this.quotation_pamudik_birthdate_menu ||
      this.select_gender ||
      this.select_period ||
      this.select_information ||
      this.dialog_tsi ||
      this.select_agen ||
      this.dialog_insured ||
      this.dialog_phone ||
      this.dialog_email ||
      this.dialog_address ||
      this.dialog_zipcode ||
      this.dialog_confirm
    ) {
      this.quotation_pamudik_birthdate_menu = false;
      this.select_gender = false;
      this.select_period = false;
      this.select_information = false;
      this.dialog_tsi = false;
      this.select_agen = false;
      this.dialog_insured = false;
      this.dialog_phone = false;
      this.dialog_email = false;
      this.dialog_address = false;
      this.dialog_zipcode = false;
      this.dialog_confirm = false;
      next(false);
    } else {
      next();
    }
  },
  created() {
    this.FirstLoad();
  },
  methods: {
    StartLoading(
      title = "Memproses Data",
      subtitle = "Mohon tunggu sebentar..."
    ) {
      this.loading_title = title;
      this.loading_subtitle = subtitle;
      this.dialog_loading = true;
    },
    StopLoading() {
      this.dialog_loading = false;
    },
    LastRegisterStorageKey() {
      return "pamudik_last_register";
    },
    LoadLastRegisterMeta() {
      try {
        if (typeof localStorage === "undefined") {
          return;
        }
        const raw = localStorage.getItem(this.LastRegisterStorageKey());
        if (!raw) {
          return;
        }
        const parsed = JSON.parse(raw);
        this.last_register_row = `${parsed.fastflow_row || ""}`.trim();
        this.last_register_id = `${parsed.fastflow_id || ""}`.trim();
      } catch (error) {
        this.last_register_row = "";
        this.last_register_id = "";
      }
    },
    SaveLastRegister(row, id = "") {
      const lastRow = `${row || ""}`.trim();
      if (!lastRow) {
        return;
      }
      const payload = {
        fastflow_row: lastRow,
        fastflow_id: `${id || this.payment_fastflow_id || ""}`.trim(),
        saved_at: new Date().toISOString()
      };
      this.last_register_row = payload.fastflow_row;
      this.last_register_id = payload.fastflow_id;
      try {
        if (typeof localStorage !== "undefined") {
          localStorage.setItem(
            this.LastRegisterStorageKey(),
            JSON.stringify(payload)
          );
        }
      } catch (error) {
        // ignore localStorage write errors
      }
    },
    ResumeLastRegister() {
      if (!this.last_register_row) {
        this.snackbar_dialog = true;
        this.snackbar_text = "Belum ada data register yang tersimpan.";
        return;
      }
      this.LoadData(this.last_register_row);
      this.steppers = 4;
      this.snackbar_dialog = true;
      this.snackbar_text = "Data register terakhir berhasil dimuat.";
    },
    SearchRegisteredData() {
      const query = `${this.search_register_query || ""}`.trim();
      if (query === "") {
        this.snackbar_dialog = true;
        this.snackbar_text =
          "Masukkan No Register atau No KTP terlebih dahulu.";
        return;
      }
      this.search_register_loading = true;
      const formData = new FormData();
      formData.append("datavalue", query);
      formData.append("fastflow_id", query);
      formData.append("fastflow_idno", query);
      formData.append("fastflow_top", "PAMUDIK");
      this.$axios
        .post(this.$functions.SafeURL("apiListFastFlow", ""), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          const rows = Array.isArray(response.data) ? response.data : [];
          const candidates = rows.filter(item => item && item.fastflow_row);
          const queryUpper = query.toUpperCase();
          const exact = candidates.find(item => {
            const reg = `${item.fastflow_id || ""}`.trim().toUpperCase();
            const idno = `${item.fastflow_idno || ""}`.trim();
            return reg === queryUpper || idno === query;
          });
          const selected = exact || candidates[0];
          if (!selected || !selected.fastflow_row) {
            this.snackbar_dialog = true;
            this.snackbar_text = "Data tidak ditemukan.";
            return;
          }
          this.SaveLastRegister(selected.fastflow_row, selected.fastflow_id);
          this.LoadData(selected.fastflow_row);
          this.steppers = 4;
          this.snackbar_dialog = true;
          this.snackbar_text = "Data register berhasil dimuat.";
        })
        .catch(() => {
          this.snackbar_dialog = true;
          this.snackbar_text = "Gagal mengambil data register.";
        })
        .finally(() => {
          this.search_register_loading = false;
        });
    },
    FirstLoad() {
      this.LoadLastRegisterMeta();
      this.informations = [
        {
          information_id: "A",
          information_desc: "Meninggal Dunia karena Kecelakaan"
        },
        {
          information_id: "B",
          information_desc: "Cacat Tetap karena Kecelakaan"
        },
        {
          information_id: "C",
          information_desc: "Biaya Perawatan karena Kecelakaan"
        },
        {
          information_id: "Plus",
          information_desc: "Biaya Ambulans + Santunan Kebakaran Kontribusi"
        }
      ];
      this.classs = [
        { gendtab_id: "L", gendtab_desc: "Laki-Laki" },
        { gendtab_id: "P", gendtab_desc: "Perempuan" }
      ];
      if (this.$route.params.id !== undefined) {
        this.LoadData(this.$route.params.id);
      }
      // Check Source
      if (
        this.$functions.GetIDSource() !== "" &&
        this.$functions.GetIDSource() !== undefined
      ) {
        this.quotation_pamudik_sourceid = this.$functions.GetIDSource();
        this.quotation_pamudik_sourceflag = false;
      }
    },
    OnGenderWebChange(id) {
      let selected = this.classs.find(item => item.gendtab_id === id);
      this.quotation_pamudik_genderdesc = selected ? selected.gendtab_desc : "";
    },
    FormSelect(select) {
      switch (select) {
        case "birthdate":
          this.quotation_pamudik_birthdate_menu = true;
          break;
        case "gender":
          //Job Occupation
          this.select_gender = true;
          break;
        case "tsi":
          //TSI
          this.dialog_tsi = true;
          this.$refs.quotation_pamudik_tsi.$el.getElementsByTagName(
            "input"
          )[0].value = this.quotation_pamudik_tsi;
          setTimeout(function() {
            document.getElementById("quotation_pamudik_tsi").focus();
          }, 500);
          break;
        case "period":
          //Period
          this.select_period = true;
          this.periods = [
            { period_id: 1, period_desc: 1 },
            { period_id: 2, period_desc: 2 },
            { period_id: 3, period_desc: 3 },
            { period_id: 4, period_desc: 4 },
            { period_id: 5, period_desc: 5 }
          ];
          break;
        case "insured":
          //Insured Name
          this.dialog_insured = true;
          setTimeout(function() {
            document.getElementById("quotation_pamudik_insured").focus();
          }, 500);
          break;
        case "agen":
          //Agen
          this.select_agen = true;
          setTimeout(function() {
            document.getElementById("select_agen_search").focus();
          }, 500);
          break;
        case "phone":
          //Insured Phone
          this.dialog_phone = true;
          setTimeout(function() {
            document.getElementById("quotation_pamudik_phone").focus();
          }, 500);
          break;
        case "email":
          //Insured Email
          this.dialog_email = true;
          setTimeout(function() {
            document.getElementById("quotation_pamudik_email").focus();
          }, 500);
          break;
        case "address":
          //Insured Address
          this.dialog_address = true;
          setTimeout(function() {
            document.getElementById("quotation_pamudik_address").focus();
          }, 500);
          break;
        case "zipcode":
          //Insured Zipcode
          this.dialog_zipcode = true;
          setTimeout(function() {
            document.getElementById("quotation_pamudik_zipcode").focus();
          }, 500);
          break;
        case "idno":
          //ID No
          this.dialog_idno = true;
          setTimeout(function() {
            document.getElementById("quotation_pamudik_idno").focus();
          }, 500);
          break;
      }
    },
    FormSelectChoose(type, id, desc) {
      switch (type) {
        case "birthdate":
          //Birthdate
          this.$refs.quotation_pamudik_birthdate_dialog.save(id);
          this.quotation_pamudik_birthdate_date = this.$moment(desc).format(
            "YYYY-MM-DD"
          );
          break;
        case "period":
          this.quotation_pamudik_period = id;
          this.quotation_pamudik_period = desc;
          this.select_period = false;
          break;
        case "insured":
          this.quotation_pamudik_insured = this.quotation_pamudik_insured_confirm;
          this.dialog_insured = false;
          break;
        case "agen":
          this.quotation_pamudik_sourceid = id;
          this.quotation_pamudik_sourcedesc = desc;
          this.select_agen = false;
          break;
        case "phone":
          this.quotation_pamudik_phone = this.quotation_pamudik_phone_confirm;
          this.dialog_phone = false;
          break;
        case "email":
          this.quotation_pamudik_email = this.quotation_pamudik_email_confirm;
          this.dialog_email = false;
          break;
        case "address":
          this.quotation_pamudik_address = this.quotation_pamudik_address_confirm;
          this.dialog_address = false;
          break;
        case "zipcode":
          this.quotation_pamudik_zipcode = this.quotation_pamudik_zipcode_confirm;
          this.dialog_zipcode = false;
          break;
        case "gender":
          this.quotation_pamudik_genderid = id;
          this.quotation_pamudik_genderdesc = desc;
          this.select_gender = false;
          break;
        case "idno":
          this.quotation_pamudik_idno = this.quotation_pamudik_idno_confirm;
          this.dialog_idno = false;
          break;
        case "inception":
          this.$refs.quotation_pamudik_inception.save(id);
          this.quotation_pamudik_inception_date = this.$moment(desc).format(
            "YYYY-MM-DD"
          );
          this.quotation_pamudik_expiry_date = this.$moment(desc)
            .add(this.quotation_pamudik_period * 1, "days")
            .format("YYYY-MM-DD");
          this.quotation_pamudik_expiry = this.quotation_pamudik_expiry_date;
          break;
      }
    },
    //TSI Confirm
    TSIConfirm() {
      let min = 0;
      let max = 200000000;
      let newconfirm = this.ReplaceAllString(
        this.quotation_pamudik_tsi_confirm,
        ".",
        ""
      );
      if (newconfirm < min || newconfirm > max) {
        this.dialog_notification = true;
        this.dialog_notification_text =
          "Mohon masukkan TSI antara " +
          this.FormatNumber(min) +
          " dan " +
          this.FormatNumber(max);
        this.dialog_notification_flag = false;
      } else {
        this.quotation_pamudik_tsi = this.quotation_pamudik_tsi_confirm;
        this.dialog_tsi = false;
      }
    },
    //NextStep
    NextStep(id) {
      if (id === 1) {
        if (this.$refs.form_quotation_step1.validate()) {
          this.steppers = 2;
          if (this.fastflow_status === "") {
            let valuetsi = this.quotation_pamudik_package * 1;
            this.quotation_pamudik_tsi = this.FormatNumber(valuetsi, 0);
            this.quotation_pamudik_tsi_confirm = valuetsi;
          }
        }
      } else if (id === 2) {
        if (this.$refs.form_quotation_step2.validate()) {
          this.StartLoading(
            "Menghitung Kontribusi",
            "Menyiapkan simulasi kontribusi terbaik untuk Anda."
          );
          let formData = new FormData();
          formData.append("fastflowrate_category", "PAMUDIK");
          formData.append(
            "fastflowrate_birthdate",
            this.quotation_pamudik_birthdate_date
          );
          formData.append("fastflowrate_benefit", this.quotation_pamudik_main);
          formData.append("fastflowrate_tsi", this.quotation_pamudik_tsi);
          formData.append("fastflowrate_period", this.quotation_pamudik_period);
          this.$axios
            .post(
              this.$functions.SafeURL("apiListFastFlowRate", ``),
              formData,
              {
                headers: {
                  "Content-Type": "multipart/form-data"
                }
              }
            )
            .then(response => {
              this.dialog_confirm = false;
              if (response.data.length === 0) {
                this.StopLoading();
                this.dialog_notification = true;
                this.dialog_notification_text =
                  "Data yang dimasukkan tidak dalam kategori Fastflow";
                this.dialog_notification_flag = false;
              } else {
                if (response.data[0].feedback === "Y") {
                  this.StopLoading();
                  this.results = response.data;
                  this.quotation_pamudik_sourceujroh =
                    response.data[0].fastflowrate_sourceujroh;
                  this.fastflowrate_min = response.data[0].fastflowrate_min;
                  this.fastflowrate_cont_min =
                    response.data[0].fastflowrate_cont_min;
                  this.fastflowrate_cont_max =
                    response.data[0].fastflowrate_cont_max;
                  if (this.quotation_pamudik_policyflag === "E") {
                    this.fastflowrate_feeduty = 0;
                  } else if (this.quotation_pamudik_policyflag === "H") {
                    this.fastflowrate_feeduty =
                      response.data[0].fastflowrate_feeduty;
                  }
                  let additional_max = 0;
                  let additional_min = 0;
                  let countdiscount = 1;
                  let pamudiktsi =
                    this.ReplaceAllString(this.quotation_pamudik_tsi, ".", "") *
                    1;
                  let accumulationtsi = 0;
                  if (
                    this.quotation_pamudik_mate !== "" &&
                    this.quotation_pamudik_mate != null
                  ) {
                    additional_max += response.data[0].fastflowrate_cont_max;
                    additional_min += response.data[0].fastflowrate_cont_min;
                    this.fastflowrate_mate =
                      response.data[0].fastflowrate_cont_min;
                    accumulationtsi += pamudiktsi;
                    countdiscount += 1;
                  }
                  if (
                    this.quotation_pamudik_father !== "" &&
                    this.quotation_pamudik_father != null
                  ) {
                    additional_max += response.data[0].fastflowrate_cont_max;
                    additional_min += response.data[0].fastflowrate_cont_min;
                    this.fastflowrate_father =
                      response.data[0].fastflowrate_cont_min;
                    accumulationtsi += pamudiktsi;
                    countdiscount += 1;
                  }
                  if (
                    this.quotation_pamudik_mother !== "" &&
                    this.quotation_pamudik_mother != null
                  ) {
                    additional_max += response.data[0].fastflowrate_cont_max;
                    additional_min += response.data[0].fastflowrate_cont_min;
                    this.fastflowrate_mother =
                      response.data[0].fastflowrate_cont_min;
                    accumulationtsi += pamudiktsi;
                    countdiscount += 1;
                  }
                  if (
                    this.quotation_pamudik_child1 !== "" &&
                    this.quotation_pamudik_child1 != null
                  ) {
                    additional_max += response.data[0].fastflowrate_cont_max;
                    additional_min += response.data[0].fastflowrate_cont_min;
                    this.fastflowrate_child1 =
                      response.data[0].fastflowrate_cont_min;
                    accumulationtsi += pamudiktsi;
                    countdiscount += 1;
                  }
                  if (
                    this.quotation_pamudik_child2 !== "" &&
                    this.quotation_pamudik_child2 != null
                  ) {
                    additional_max += response.data[0].fastflowrate_cont_max;
                    additional_min += response.data[0].fastflowrate_cont_min;
                    this.fastflowrate_child2 =
                      response.data[0].fastflowrate_cont_min;
                    accumulationtsi += pamudiktsi;
                    countdiscount += 1;
                  }
                  if (
                    this.quotation_pamudik_child3 !== "" &&
                    this.quotation_pamudik_child3 != null
                  ) {
                    additional_max += response.data[0].fastflowrate_cont_max;
                    additional_min += response.data[0].fastflowrate_cont_min;
                    this.fastflowrate_child3 =
                      response.data[0].fastflowrate_cont_min;
                    accumulationtsi += pamudiktsi;
                    countdiscount += 1;
                  }
                  if (
                    this.quotation_pamudik_child4 !== "" &&
                    this.quotation_pamudik_child4 != null
                  ) {
                    additional_max += response.data[0].fastflowrate_cont_max;
                    additional_min += response.data[0].fastflowrate_cont_min;
                    this.fastflowrate_child4 =
                      response.data[0].fastflowrate_cont_min;
                    accumulationtsi += pamudiktsi;
                    countdiscount += 1;
                  }
                  if (
                    this.quotation_pamudik_child5 !== "" &&
                    this.quotation_pamudik_child5 != null
                  ) {
                    additional_max += response.data[0].fastflowrate_cont_max;
                    additional_min += response.data[0].fastflowrate_cont_min;
                    this.fastflowrate_child5 =
                      response.data[0].fastflowrate_cont_min;
                    accumulationtsi += pamudiktsi;
                    countdiscount += 1;
                  }
                  let discount = countdiscount / 5;
                  let floordiscountmin =
                    Math.floor(discount) *
                    response.data[0].fastflowrate_cont_min;
                  let floordiscountmax =
                    Math.floor(discount) *
                    response.data[0].fastflowrate_cont_max;
                  this.fastflowrate_discount = floordiscountmin;
                  this.fastflowrate_cont_total_min =
                    response.data[0].fastflowrate_cont_min +
                    response.data[0].fastflowrate_feeduty +
                    additional_min -
                    floordiscountmin;
                  this.fastflowrate_cont_total_max =
                    response.data[0].fastflowrate_cont_max +
                    response.data[0].fastflowrate_feeduty +
                    additional_max -
                    floordiscountmax;
                  this.quotation_pamudik_addtsi = accumulationtsi;
                  this.steppers = 3;
                } else {
                  this.StopLoading();
                  this.dialog_notification = true;
                  this.dialog_notification_text = response.data[0].feedback;
                  this.dialog_notification_flag = false;
                }
              }
            })
            .catch(e => {
              this.StopLoading();
              this.dialog_notification = true;
              this.dialog_notification_text = e.response;
              this.dialog_notification_flag = false;
            });
        }
      }
    },
    //Format Number
    FormatNumber(value, fixed) {
      return this.$functions.FormatNumber(value, fixed);
    },
    //MappingDescription
    MappingDescription(id) {
      let returns = "";
      switch (id) {
        case "MUDIK":
          returns = "MUDIK";
          break;
      }
      let uppercase = returns.toUpperCase();
      return uppercase;
    },
    SearchData() {
      if (this.select_agen_search !== "") {
        this.loading_agen = true;
        this.$axios
          .post(
            this.$functions.SafeURL(
              "apiListCareProfile",
              `careprofile_intermediaryf=1&careprofile_ptype=M&datavalue=` +
                this.select_agen_search
            )
          )
          .then(response => {
            if (response.data[0].feedback === "Y") {
              this.agens = response.data;
            } else {
              this.snackbar_dialog = true;
              this.snackbar_text = "Unable connection to Core";
            }
            this.loading_agen = false;
          })
          .catch(e => {
            this.snackbar_dialog = true;
            this.snackbar_text = e;
            this.loading_agen = false;
          });
      }
    },
    IsRegisterLocked() {
      return (
        this.payment_ready || (this.url_type === "edit" && !!this.fastflow_row)
      );
    },
    //Confirm Process
    ConfirmData() {
      if (this.IsRegisterLocked()) {
        this.snackbar_dialog = true;
        this.snackbar_text = "Data sudah ter-register.";
        return;
      }
      if (this.$refs.form_quotation_step3.validate()) {
        this.fastflow_confirm = "";
        this.dialog_confirm = true;
        this.title_confirm = "Proses Register?";
        this.url_type = "add";
        setTimeout(function() {
          document.getElementById("dialog_confirm_true").focus();
        }, 500);
      }
    },
    //Process and Save Data
    ProcessData() {
      this.StartLoading(
        "Memproses Registrasi",
        "Menyimpan data peserta dan menyiapkan nomor register."
      );
      let formData = new FormData();
      let today = this.$functions.Today();
      // let periods  = this.quotation_pamudik_period * 1
      // let enddate  = this.$functions.FormatNewDate(new Date().setDate(new Date().getDate() + periods))
      // Check Flag Upload
      let channel = "AGENCY";
      if (this.quotation_pamudik_sourceid === "") {
        channel = "DIRECT";
      }
      formData.append("url_type", this.url_type);
      formData.append("fastflow_row", this.fastflow_row);
      formData.append("fastflow_type", "N");
      formData.append("fastflow_toc", "1004");
      formData.append("fastflow_top", "PAMUDIK");
      formData.append("fastflow_signdate", today);
      formData.append("fastflow_signby", this.quotation_pamudik_insured);
      formData.append("fastflow_sourcedate", today);
      formData.append("fastflow_sourceby", this.quotation_pamudik_sourceid);
      formData.append("fastflow_branchdate", today);
      formData.append("fastflow_branchby", this.$functions.UsersID());
      formData.append("fastflow_idno", this.quotation_pamudik_idno);
      formData.append("fastflow_insured", this.quotation_pamudik_insured);
      formData.append("fastflow_address", this.quotation_pamudik_address);
      formData.append("fastflow_zipcode", this.quotation_pamudik_zipcode);
      formData.append("fastflow_phone", this.quotation_pamudik_phone);
      formData.append("fastflow_email", this.quotation_pamudik_email);
      formData.append("fastflow_policyflag", this.quotation_pamudik_policyflag);
      formData.append("fastflow_fieldid_1", "B01");
      formData.append("fastflow_fieldvalueid_1", "");
      formData.append(
        "fastflow_fieldvaluedesc_1",
        this.quotation_pamudik_birthdate_date
      );
      formData.append("fastflow_fieldid_2", "G01");
      formData.append(
        "fastflow_fieldvalueid_2",
        this.quotation_pamudik_genderid
      );
      formData.append(
        "fastflow_fieldvaluedesc_2",
        this.quotation_pamudik_genderdesc
      );
      formData.append("fastflow_fieldid_3", "H01");
      formData.append("fastflow_fieldvalueid_3", "");
      formData.append(
        "fastflow_fieldvaluedesc_3",
        this.quotation_pamudik_heirs
      );
      formData.append("fastflow_fieldid_4", "N02");
      formData.append("fastflow_fieldvalueid_4", "");
      formData.append("fastflow_fieldvaluedesc_4", this.quotation_pamudik_mate);
      formData.append("fastflow_fieldid_5", "N09");
      formData.append("fastflow_fieldvalueid_5", "");
      formData.append(
        "fastflow_fieldvaluedesc_5",
        this.quotation_pamudik_father
      );
      formData.append("fastflow_fieldid_6", "N10");
      formData.append("fastflow_fieldvalueid_6", "");
      formData.append(
        "fastflow_fieldvaluedesc_6",
        this.quotation_pamudik_mother
      );
      formData.append("fastflow_fieldid_7", "N03");
      formData.append("fastflow_fieldvalueid_7", "");
      formData.append(
        "fastflow_fieldvaluedesc_7",
        this.quotation_pamudik_child1
      );
      formData.append("fastflow_fieldid_8", "N04");
      formData.append("fastflow_fieldvalueid_8", "");
      formData.append(
        "fastflow_fieldvaluedesc_8",
        this.quotation_pamudik_child2
      );
      formData.append("fastflow_fieldid_9", "N05");
      formData.append("fastflow_fieldvalueid_9", "");
      formData.append(
        "fastflow_fieldvaluedesc_9",
        this.quotation_pamudik_child3
      );
      formData.append("fastflow_fieldid_10", "N07");
      formData.append("fastflow_fieldvalueid_10", "");
      formData.append(
        "fastflow_fieldvaluedesc_10",
        this.quotation_pamudik_child4
      );
      formData.append("fastflow_fieldid_11", "N08");
      formData.append("fastflow_fieldvalueid_11", "");
      formData.append(
        "fastflow_fieldvaluedesc_11",
        this.quotation_pamudik_child5
      );
      formData.append("fastflow_tsi", this.quotation_pamudik_tsi);
      formData.append("fastflow_add_tsi", this.quotation_pamudik_addtsi);
      formData.append("fastflow_sdate", this.quotation_pamudik_inception_date);
      formData.append("fastflow_edate", this.quotation_pamudik_expiry_date);
      formData.append("fastflow_period", this.quotation_pamudik_period);
      formData.append("fastflow_main_type", this.quotation_pamudik_main);
      formData.append("fastflow_main_rate", this.fastflowrate_min);
      formData.append("fastflow_main_unit", "M");
      formData.append(
        "fastflow_main_cont",
        this.fastflowrate_cont_total_min + this.fastflowrate_discount
      );
      formData.append("fastflow_feeduty", this.fastflowrate_feeduty);
      formData.append("fastflow_discount", this.fastflowrate_discount);
      formData.append("fastflow_channel", channel);
      formData.append("fastflow_segment", "PERSONAL");
      formData.append("fastflow_instype", "D");
      formData.append(
        "fastflow_sourceujroh",
        this.quotation_pamudik_sourceujroh
      );
      formData.append("fastflow_upload", "");
      formData.append("fastflow_forcecovernote", "Y");
      formData.append("fastflow_periodunit", "D");
      this.$axios
        .post(this.$functions.SafeURL("apiWritePAMudik", ``), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.dialog_confirm = false;
          if (response.data[0].feedback === "Y") {
            this.url_type = "edit";
            this.StopLoading();
            this.fastflow_row = response.data[0].fastflow_row || "";
            this.ApplyPaymentRecord(response.data[0]);
            this.CheckPaymentStatus(false, true);
          } else {
            this.StopLoading();
            this.dialog_notification = true;
            this.dialog_notification_text = response.data[0].feedback;
            this.dialog_notification_flag = false;
            this.dialog_confirm = false;
          }
        })
        .catch(e => {
          this.dialog_confirm = false;
          this.StopLoading();
          this.dialog_notification = true;
          this.dialog_notification_text = e.response;
          this.dialog_notification_flag = false;
          this.dialog_confirm = false;
        });
    },
    FindValueByKeys(record, keys) {
      for (const key of keys) {
        const value = record ? record[key] : "";
        if (value !== undefined && value !== null && `${value}`.trim() !== "") {
          return `${value}`.trim();
        }
      }
      return "";
    },
    ExtractVirtualAccount(record, bankCode) {
      if (!record) {
        return "";
      }
      const bank = (bankCode || "").toLowerCase();
      const directKeys =
        bank === "bmi"
          ? [
              "fastflow_va_bmi",
              "fastflow_virtualaccount_bmi",
              "fastflow_virtual_account_bmi",
              "payment_va_bmi",
              "va_bmi",
              "vaccount_bmi",
              "fastflow_bank_va_bmi",
              "fastflow_bank_bmi_va",
              "fastflow_paidvano"
            ]
          : [
              "fastflow_va_bca",
              "fastflow_virtualaccount_bca",
              "fastflow_virtual_account_bca",
              "payment_va_bca",
              "va_bca",
              "vaccount_bca",
              "fastflow_bank_va_bca",
              "fastflow_bank_bca_va",
              "fastflow_paidvano1"
            ];
      const directValue = this.FindValueByKeys(record, directKeys);
      if (directValue !== "") {
        return directValue;
      }
      const found = Object.entries(record).find(([key, value]) => {
        const k = key.toLowerCase();
        if (value === undefined || value === null || `${value}`.trim() === "") {
          return false;
        }
        const hasBankName = k.includes(bank);
        const hasVAInfo =
          k.includes("va") || k.includes("virtual") || k.includes("account");
        return hasBankName && hasVAInfo;
      });
      return found ? `${found[1]}`.trim() : "";
    },
    GetPaymentEvidence(record) {
      const source = record || {};
      return {
        paidBy: this.FindValueByKeys(source, ["fastflow_paidby", "paidby"]),
        paidDate: this.FindValueByKeys(source, [
          "fastflow_paiddate",
          "paiddate"
        ]),
        paidRefNo: this.FindValueByKeys(source, [
          "fastflow_paidrefno",
          "fastflow_paidno",
          "paidrefno",
          "paidno"
        ]),
        trxId: this.FindValueByKeys(source, [
          "fastflow_trx_id",
          "fastflow_trxid",
          "trx_id"
        ])
      };
    },
    HasCompletePaymentEvidence(record) {
      const evidence = this.GetPaymentEvidence(record);
      return [
        evidence.paidBy,
        evidence.paidDate,
        evidence.paidRefNo,
        evidence.trxId
      ].every(value => `${value || ""}`.trim() !== "");
    },
    HasBasicPaymentEvidence(record) {
      const evidence = this.GetPaymentEvidence(record);
      const hasIdentity =
        `${evidence.paidBy || ""}`.trim() !== "" &&
        `${evidence.paidDate || ""}`.trim() !== "";
      const hasReference =
        `${evidence.paidRefNo || ""}`.trim() !== "" ||
        `${evidence.trxId || ""}`.trim() !== "";
      return hasIdentity && hasReference;
    },
    PaymentStatusPaid(status, statusDesc, record = null) {
      const paymentRecord = record || {
        fastflow_paidby: this.payment_paidby,
        fastflow_paiddate: this.payment_paiddate,
        fastflow_paidrefno: this.payment_paidrefno,
        fastflow_trx_id: this.payment_trx_id
      };
      if (this.HasCompletePaymentEvidence(paymentRecord)) {
        return true;
      }
      if (this.HasBasicPaymentEvidence(paymentRecord)) {
        return true;
      }
      const rawStatus = `${status || ""}`.trim().toUpperCase();
      const fullStatus = `${status || ""} ${statusDesc || ""}`.toUpperCase();
      if (
        ["P", "PAID", "LUNAS", "SETTLED", "SUCCESS", "D"].includes(rawStatus)
      ) {
        return true;
      }
      return [
        "PAID",
        "LUNAS",
        "SETTLED",
        "SUCCESS",
        "SUKSES",
        "TERBAYAR",
        "DELIVERED"
      ].some(token => fullStatus.includes(token));
    },
    ApplyPaymentRecord(record) {
      if (!record) {
        return;
      }
      this.payment_fastflow_row =
        record.fastflow_row || this.payment_fastflow_row || this.fastflow_row;
      this.payment_fastflow_id = record.fastflow_id || this.payment_fastflow_id;
      this.payment_fastflow_status =
        record.fastflow_status || this.payment_fastflow_status;
      this.payment_status_desc =
        record.fastflow_statusdesc ||
        record.fastflow_status_desc ||
        this.payment_fastflow_status;
      const epolicyUrl = this.FindValueByKeys(record, [
        "fastflow_epolicy_url",
        "epolicy_url",
        "policy_url",
        "fastflow_url"
      ]);
      this.payment_epolicy_url = epolicyUrl || this.payment_epolicy_url;
      const bmiVA = this.ExtractVirtualAccount(record, "bmi");
      const bcaVA = this.ExtractVirtualAccount(record, "bca");
      this.payment_va_bmi = bmiVA || this.payment_va_bmi;
      this.payment_va_bca = bcaVA || this.payment_va_bca;
      const evidence = this.GetPaymentEvidence(record);
      this.payment_paidby = evidence.paidBy || this.payment_paidby;
      this.payment_paiddate = evidence.paidDate || this.payment_paiddate;
      this.payment_paidrefno = evidence.paidRefNo || this.payment_paidrefno;
      this.payment_trx_id = evidence.trxId || this.payment_trx_id;
      this.payment_ready = this.payment_fastflow_row !== "";
      this.SaveLastRegister(
        this.payment_fastflow_row,
        this.payment_fastflow_id
      );
    },
    BuildPaymentInstruction() {
      const statusLabel =
        this.payment_status_desc ||
        this.payment_fastflow_status ||
        "Menunggu pembayaran";
      const registerNo = this.payment_fastflow_id || "-";
      const vaBmi = this.payment_va_bmi || "-";
      const vaBca = this.payment_va_bca || "-";
      return (
        "Register berhasil: <b>" +
        registerNo +
        "</b><br>" +
        "VA BMI: <b>" +
        vaBmi +
        "</b><br>" +
        "VA BCA: <b>" +
        vaBca +
        "</b><br>" +
        "Status: <b>" +
        statusLabel +
        "</b><br>" +
        "Policy akan muncul setelah pembayaran tervalidasi."
      );
    },
    CopyVirtualAccount(bankName, vaNumber) {
      const value = `${vaNumber || ""}`.trim();
      if (value === "" || value === "-") {
        this.snackbar_dialog = true;
        this.snackbar_text = `VA ${bankName} belum tersedia.`;
        return;
      }
      const successMessage = () => {
        this.snackbar_dialog = true;
        this.snackbar_text = `VA ${bankName} berhasil disalin.`;
      };
      const failMessage = () => {
        this.snackbar_dialog = true;
        this.snackbar_text = `VA ${bankName} gagal disalin, silakan copy manual.`;
      };
      const fallbackCopy = () => {
        try {
          const temp = document.createElement("textarea");
          temp.value = value;
          temp.setAttribute("readonly", "");
          temp.style.position = "absolute";
          temp.style.left = "-9999px";
          document.body.appendChild(temp);
          temp.select();
          const ok = document.execCommand("copy");
          document.body.removeChild(temp);
          if (ok) {
            successMessage();
            return;
          }
          failMessage();
        } catch (error) {
          failMessage();
        }
      };
      if (
        typeof navigator !== "undefined" &&
        navigator.clipboard &&
        navigator.clipboard.writeText
      ) {
        navigator.clipboard
          .writeText(value)
          .then(() => successMessage())
          .catch(() => fallbackCopy());
        return;
      }
      fallbackCopy();
    },
    CheckPaymentStatus(openPolicyWhenPaid = false, showDialog = true) {
      const fastflowRow = this.payment_fastflow_row || this.fastflow_row;
      if (!fastflowRow) {
        this.snackbar_dialog = true;
        this.snackbar_text = "Data register belum tersedia.";
        return;
      }
      this.payment_checking = true;
      const formData = new FormData();
      formData.append("fastflow_row", fastflowRow);
      this.$axios
        .post(this.$functions.SafeURL("apiListFastFlow", ""), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          const record =
            response.data && response.data[0] ? response.data[0] : null;
          this.ApplyPaymentRecord(record);
          this.payment_checking = false;
          const paid = this.PaymentStatusPaid(
            this.payment_fastflow_status,
            this.payment_status_desc,
            record
          );
          if (openPolicyWhenPaid && paid) {
            this.OpenPolicyAfterPayment();
            return;
          }
          this.payment_dialog_paid = paid;
          if (showDialog) {
            this.dialog_payment_info = true;
          }
        })
        .catch(e => {
          this.payment_checking = false;
          this.dialog_notification = true;
          this.dialog_notification_flag = false;
          this.dialog_notification_text =
            e.response || "Gagal cek status pembayaran";
        });
    },
    OpenPolicyAfterPayment() {
      const policyUrl = `${this.payment_epolicy_url || ""}`.trim();
      if (policyUrl !== "") {
        const opened = window.open(policyUrl, "_blank");
        if (!opened) {
          window.location.href = policyUrl;
        }
        return;
      }
      const routePayload = {
        name: "policyfastflowdetail",
        params: { id: this.payment_fastflow_row || this.fastflow_row }
      };
      const resolved = this.$router.resolve(routePayload);
      if (resolved && resolved.route && resolved.route.name) {
        this.$router.push(routePayload);
        return;
      }
      this.dialog_notification = true;
      this.dialog_notification_flag = true;
      this.dialog_notification_text =
        "Pembayaran sudah tervalidasi. Halaman policy belum tersedia di website ini, silakan lanjutkan dari menu policy internal.";
    },
    //Function to Replace All String
    ReplaceAllString(str, find, replace) {
      return str.replace(
        new RegExp(find.replace(/[-/\\^$*+?.()|[\]{}]/g, "\\$&"), "g"),
        replace
      );
    },
    // Load Data
    LoadData(id) {
      let formData = new FormData();
      formData.append("fastflow_row", id);
      this.$axios
        .post(this.$functions.SafeURL("apiListFastFlow", ""), formData, {
          headers: {
            "Content-Type": "multipart/form-data"
          }
        })
        .then(response => {
          this.url_type = "edit";
          this.fastflow_row = response.data[0].fastflow_row;
          this.fastflow_status = response.data[0].fastflow_status;
          this.SaveLastRegister(
            response.data[0].fastflow_row,
            response.data[0].fastflow_id
          );
          this.ApplyPaymentRecord(response.data[0]);
          this.quotation_pamudik_package = Math.round(
            response.data[0].fastflow_tsi
          ).toString();
          this.quotation_pamudik_birthdate_date =
            response.data[0].fastflow_fieldvaluedesc_1;
          this.quotation_pamudik_birthdate =
            response.data[0].fastflow_fieldvaluedesc_1;
          this.quotation_pamudik_genderid =
            response.data[0].fastflow_fieldvalueid_2;
          this.quotation_pamudik_genderdesc =
            response.data[0].fastflow_fieldvaluedesc_2;
          this.quotation_pamudik_heirs =
            response.data[0].fastflow_fieldvaluedesc_3;
          this.quotation_pamudik_heirs_confirm =
            response.data[0].fastflow_fieldvaluedesc_3;
          this.quotation_pamudik_main = response.data[0].fastflow_main_type;
          this.quotation_pamudik_tsi = this.FormatNumber(
            response.data[0].fastflow_tsi
          );
          this.quotation_pamudik_tsi_confirm = response.data[0].fastflow_tsi;
          this.quotation_pamudik_policyflag =
            response.data[0].fastflow_policyflag;
          this.quotation_pamudik_idno = response.data[0].fastflow_idno;
          this.quotation_pamudik_idno_confirm = response.data[0].fastflow_idno;
          this.quotation_pamudik_insured = response.data[0].fastflow_insured;
          this.quotation_pamudik_insured_confirm =
            response.data[0].fastflow_insured;
          this.quotation_pamudik_sourceid = response.data[0].fastflow_source;
          this.quotation_pamudik_sourcedesc =
            response.data[0].fastflow_sourcename;
          this.quotation_pamudik_sourceujroh =
            response.data[0].fastflow_sourceujroh;
          this.quotation_pamudik_phone = response.data[0].fastflow_phone;
          this.quotation_pamudik_phone_confirm =
            response.data[0].fastflow_phone;
          this.quotation_pamudik_email = response.data[0].fastflow_email;
          this.quotation_pamudik_email_confirm =
            response.data[0].fastflow_email;
          this.quotation_pamudik_address = response.data[0].fastflow_address;
          this.quotation_pamudik_address_confirm =
            response.data[0].fastflow_address;
          this.quotation_pamudik_zipcode = response.data[0].fastflow_zipcode;
          this.quotation_pamudik_zipcode_confirm =
            response.data[0].fastflow_zipcode;
        });
    },
    AddFamily() {
      this.dialog_family = true;
      setTimeout(function() {
        document.getElementById("quotation_pamudik_mate").focus();
      }, 500);
    },
    CancelFamily() {
      this.quotation_pamudik_mate = "";
      this.quotation_pamudik_father = "";
      this.quotation_pamudik_mother = "";
      this.quotation_pamudik_child1 = "";
      this.quotation_pamudik_child2 = "";
      this.quotation_pamudik_child3 = "";
    }
  }
};
</script>
<style>
.pa-mudik-page {
  --pa-primary: #001f48;
  --pa-primary-dark: #00356f;
  --pa-secondary: #008493;
  --pa-accent: #3ec2d1;
  --pa-surface: #ffffff;
  --pa-muted: #f3f6fa;
  --pa-border: #dbe4ee;
  --pa-text: #1f2937;
  position: relative;
  overflow: hidden;
  min-height: 100vh;
  padding-bottom: 24px;
  color: var(--pa-text);
  font-family: "Plus Jakarta Sans", "Segoe UI", Tahoma, sans-serif;
  background: radial-gradient(
      circle at 12% 8%,
      rgba(0, 132, 147, 0.14),
      rgba(0, 132, 147, 0) 32%
    ),
    radial-gradient(
      circle at 88% 12%,
      rgba(62, 194, 209, 0.18),
      rgba(62, 194, 209, 0) 30%
    ),
    linear-gradient(180deg, #f7fafc 0%, #eef4f8 55%, #eaf1f7 100%);
}

.pa-mudik-page::before,
.pa-mudik-page::after {
  content: "";
  position: absolute;
  z-index: 0;
  pointer-events: none;
  border-radius: 999px;
}

.pa-mudik-page::before {
  width: 320px;
  height: 320px;
  top: 80px;
  right: -120px;
  background: radial-gradient(
    circle,
    rgba(0, 132, 147, 0.12),
    rgba(0, 132, 147, 0)
  );
}

.pa-mudik-page::after {
  width: 360px;
  height: 360px;
  bottom: 40px;
  left: -160px;
  background: radial-gradient(
    circle,
    rgba(0, 31, 72, 0.11),
    rgba(0, 31, 72, 0)
  );
}

.pa-mudik-page .pa-mudik-hero,
.pa-mudik-page .pa-mudik-stepper {
  position: relative;
  z-index: 1;
}

.pa-mudik-page .pa-mudik-hero {
  max-width: 1120px;
  margin: 14px auto 0;
  padding: 26px 24px 22px;
  border-radius: 22px;
  border: 1px solid rgba(148, 163, 184, 0.22);
  background: linear-gradient(
    125deg,
    rgba(0, 31, 72, 0.94) 0%,
    rgba(0, 132, 147, 0.9) 100%
  );
  box-shadow: 0 22px 40px rgba(2, 6, 23, 0.2);
  color: #fff;
}

.pa-mudik-page .pa-mudik-hero__kicker {
  margin: 0 0 8px;
  font-size: 12px;
  letter-spacing: 1.3px;
  font-weight: 700;
  opacity: 0.82;
}

.pa-mudik-page .pa-mudik-hero__title {
  margin: 0;
  max-width: 720px;
  font-size: 28px;
  line-height: 1.25;
  font-weight: 700;
}

.pa-mudik-page .pa-mudik-hero__subtitle {
  margin: 10px 0 0;
  max-width: 760px;
  font-size: 14px;
  opacity: 0.9;
}

.pa-mudik-page .pa-mudik-hero__chips {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
  margin-top: 18px;
}

.pa-mudik-page .pa-mudik-hero__progress {
  margin-top: 14px;
  max-width: 420px;
}

.pa-mudik-page .pa-mudik-hero__progress-label {
  font-size: 12px;
  font-weight: 600;
  letter-spacing: 0.6px;
  opacity: 0.88;
  margin-bottom: 8px;
}

.pa-mudik-page .pa-mudik-chip {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  border-radius: 999px;
  padding: 7px 12px;
  background: rgba(255, 255, 255, 0.12);
  border: 1px solid rgba(255, 255, 255, 0.25);
  font-size: 12px;
  font-weight: 600;
}

.pa-mudik-page .pa-mudik-chip .v-icon {
  color: #ddfbff !important;
}

.pa-mudik-page .pa-mudik-stepper {
  max-width: 1120px;
  margin: 16px auto 0;
  background: transparent !important;
}

.pa-mudik-page .pa-mudik-restore {
  max-width: 1120px;
  margin: 10px auto 0;
}

.pa-mudik-page .pa-mudik-restore__card {
  border-radius: 14px;
  border: 1px solid rgba(148, 163, 184, 0.35);
  background: rgba(255, 255, 255, 0.82);
  box-shadow: 0 8px 22px rgba(15, 23, 42, 0.08);
  display: flex;
  align-items: center;
  justify-content: space-between;
  gap: 12px;
  padding: 10px 14px;
}

.pa-mudik-page .pa-mudik-restore__label {
  font-size: 11px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
  color: #0f766e;
  font-weight: 700;
}

.pa-mudik-page .pa-mudik-restore__value {
  margin-top: 2px;
  font-size: 15px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 0.8px;
}

.pa-mudik-page .pa-mudik-restore__card--search {
  margin-top: 8px;
  flex-direction: column;
  align-items: stretch;
}

.pa-mudik-page .pa-mudik-restore__search-head {
  display: flex;
  flex-direction: column;
  gap: 3px;
}

.pa-mudik-page .pa-mudik-restore__search-hint {
  font-size: 12px;
  color: #64748b;
}

.pa-mudik-page .pa-mudik-restore__search-form {
  margin-top: 8px;
  display: flex;
  align-items: center;
  gap: 8px;
}

.pa-mudik-page .pa-mudik-restore__search-input {
  flex: 1 1 auto;
}

.pa-mudik-page .pa-mudik-stepper .v-stepper__header {
  margin: 12px auto 0;
  border-radius: 16px;
  background: rgba(255, 255, 255, 0.9);
  box-shadow: 0 12px 30px rgba(15, 23, 42, 0.08);
  border: 1px solid rgba(148, 163, 184, 0.2);
  backdrop-filter: blur(5px);
}

.pa-mudik-page .pa-mudik-stepper .v-stepper__step {
  padding: 14px 16px;
}

.pa-mudik-page .pa-mudik-stepper .v-stepper__label {
  font-weight: 600;
  color: #334155;
  letter-spacing: 0.2px;
}

.pa-mudik-page .pa-mudik-stepper .v-divider {
  border-color: rgba(148, 163, 184, 0.35);
}

.pa-mudik-page .pa-mudik-stepper .v-stepper__step__step {
  box-shadow: 0 6px 14px rgba(0, 31, 72, 0.24);
}

.pa-mudik-page
  .pa-mudik-stepper
  .v-stepper__step--active
  .v-stepper__step__step,
.pa-mudik-page
  .pa-mudik-stepper
  .v-stepper__step--complete
  .v-stepper__step__step {
  background: var(--pa-primary) !important;
  border-color: var(--pa-primary) !important;
}

.pa-mudik-page .pa-mudik-step-content {
  margin-top: 16px;
  border-radius: 22px;
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.96),
    rgba(255, 255, 255, 0.9)
  );
  border: 1px solid rgba(148, 163, 184, 0.22);
  box-shadow: 0 18px 36px rgba(15, 23, 42, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.78);
  padding: 20px 18px 22px;
  overflow: visible;
  animation: paMudikFadeIn 0.32s ease;
}

.pa-mudik-page .pa-mudik-form-shell {
  max-width: 100%;
  margin: 0 auto;
  padding: 0 12px;
}

.pa-mudik-page .pa-mudik-grid > .flex {
  padding-left: 8px;
  padding-right: 8px;
  padding-top: 6px;
  padding-bottom: 6px;
}

.pa-mudik-page .pa-mudik-grid {
  margin-left: 0 !important;
  margin-right: 0 !important;
}

.pa-mudik-page .pa-mudik-period-col {
  position: relative;
}

.pa-mudik-page .pa-mudik-period-day-col {
  max-width: 220px;
}

.pa-mudik-page .pa-mudik-period-day-input .v-input__control > .v-input__slot {
  min-height: 46px;
}

.pa-mudik-page .pa-mudik-period-day-input input {
  font-size: 18px;
  font-weight: 700;
  text-align: center;
}

.pa-mudik-page .pa-mudik-period-day-input .v-label {
  font-size: 12px;
}

.pa-mudik-page .pa-mudik-step4-shell {
  padding-left: 14px;
  padding-right: 14px;
}

.pa-mudik-page .pa-mudik-step3-shell {
  padding: 6px 16px 8px;
}

.pa-mudik-page .pa-mudik-section-head {
  margin-bottom: 10px;
}

.pa-mudik-page .pa-mudik-section-head__kicker {
  margin: 0 0 4px;
  color: #0b5f6b;
  font-size: 12px;
  font-weight: 700;
  letter-spacing: 1px;
  text-transform: uppercase;
}

.pa-mudik-page .pa-mudik-section-head__title {
  margin: 0;
  font-size: 22px;
  line-height: 1.25;
  color: #0f172a;
}

.pa-mudik-page .pa-mudik-section-head__subtitle {
  margin: 8px 0 0;
  color: #4b5563;
  font-size: 14px;
  line-height: 1.55;
  max-width: 34ch;
}

.pa-mudik-page .pa-mudik-field-label {
  margin: 0 0 10px;
  color: #0f172a;
  font-size: 13px;
  font-weight: 700;
  letter-spacing: 0.5px;
}

.pa-mudik-page .pa-mudik-step1-grid > .col {
  padding-top: 4px;
  padding-bottom: 4px;
}

.pa-mudik-page .v-radio-group.pa-mudik-package-pills {
  margin-top: 0 !important;
  border: 0 !important;
  background: transparent !important;
  padding: 0 !important;
}

.pa-mudik-page .pa-mudik-package-pills .v-input--radio-group__input {
  display: flex;
  flex-wrap: wrap;
  gap: 10px;
}

.pa-mudik-page .pa-mudik-package-pills .v-radio {
  margin: 0 !important;
}

.pa-mudik-page .pa-mudik-package-pills .v-input--selection-controls__input {
  display: none;
}

.pa-mudik-page .pa-mudik-package-pills .v-label {
  margin: 0 !important;
  min-width: 88px;
  justify-content: center;
  border-radius: 999px;
  padding: 8px 14px;
  border: 1px solid #cbd5e1;
  background: #f8fafc;
  color: #0f172a !important;
  font-size: 14px;
  font-weight: 700;
  letter-spacing: 0.2px;
  transition: all 0.2s ease;
}

.pa-mudik-page .pa-mudik-package-pills .v-radio.v-item--active .v-label {
  border-color: #0b6f8e;
  background: linear-gradient(
    135deg,
    rgba(11, 111, 142, 0.12),
    rgba(0, 132, 147, 0.15)
  );
  color: #0b3a70 !important;
  box-shadow: 0 6px 14px rgba(11, 58, 112, 0.16);
}

.pa-mudik-page .pa-mudik-total-spotlight {
  margin-bottom: 14px;
  border-radius: 16px;
  padding: 16px 18px;
  background: linear-gradient(
    140deg,
    rgba(0, 31, 72, 0.95),
    rgba(0, 132, 147, 0.92)
  );
  color: #fff;
  box-shadow: 0 14px 28px rgba(0, 31, 72, 0.24);
}

.pa-mudik-page .pa-mudik-total-spotlight--step3 {
  margin-bottom: 18px;
  border-radius: 20px;
  padding: 20px 22px;
  border: 1px solid rgba(255, 255, 255, 0.18);
  box-shadow: 0 18px 34px rgba(0, 31, 72, 0.24),
    inset 0 1px 0 rgba(255, 255, 255, 0.22);
}

.pa-mudik-page .pa-mudik-total-spotlight__label {
  margin: 0;
  opacity: 0.84;
  font-size: 12px;
  letter-spacing: 1px;
  text-transform: uppercase;
  font-weight: 600;
}

.pa-mudik-page .pa-mudik-total-spotlight__value {
  margin: 6px 0 0;
  font-size: 32px;
  line-height: 1.2;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.pa-mudik-page .pa-mudik-total-spotlight__note {
  margin: 6px 0 0;
  font-size: 13px;
  opacity: 0.9;
  max-width: 60ch;
}

.pa-mudik-page .theme--light.v-text-field > .v-input__control > .v-input__slot,
.pa-mudik-page .theme--light.v-textarea > .v-input__control > .v-input__slot {
  border-radius: 12px;
  border: 1px solid var(--pa-border);
  background: var(--pa-muted);
  min-height: 50px;
  padding: 0 12px;
  transition: border-color 0.2s ease, box-shadow 0.2s ease, transform 0.2s ease;
}

.pa-mudik-page
  .theme--light.v-text-field
  > .v-input__control
  > .v-input__slot::before,
.pa-mudik-page
  .theme--light.v-text-field
  > .v-input__control
  > .v-input__slot::after,
.pa-mudik-page
  .theme--light.v-textarea
  > .v-input__control
  > .v-input__slot::before,
.pa-mudik-page
  .theme--light.v-textarea
  > .v-input__control
  > .v-input__slot::after {
  display: none !important;
  border: 0 !important;
}

.pa-mudik-page
  .theme--light.v-text-field:not(.v-input--is-disabled)
  > .v-input__control
  > .v-input__slot:hover,
.pa-mudik-page
  .theme--light.v-textarea:not(.v-input--is-disabled)
  > .v-input__control
  > .v-input__slot:hover {
  border-color: #9bb6cd;
  transform: translateY(-1px);
}

.pa-mudik-page .v-input.v-input--is-focused .v-input__slot {
  border-color: rgba(0, 132, 147, 0.5) !important;
  box-shadow: 0 0 0 4px rgba(0, 132, 147, 0.12);
}

.pa-mudik-page .v-input__prepend-outer {
  min-width: 28px;
  margin-right: 8px;
  margin-left: 0;
  display: flex;
  align-items: center;
  justify-content: center;
}

.pa-mudik-page .v-input__prepend-outer .v-icon {
  font-size: 20px;
  line-height: 20px;
}

.pa-mudik-page .v-radio-group {
  border-radius: 12px;
  border: 1px solid var(--pa-border);
  background: #f8fbff;
  padding: 8px 12px 2px;
  margin-top: 2px;
}

.pa-mudik-page .v-input--selection-controls {
  margin-top: 0;
}

.pa-mudik-page .pa-mudik-summary-card {
  border-radius: 16px;
  border: 1px solid var(--pa-border);
  overflow: hidden;
}

.pa-mudik-page .pa-mudik-summary-card--step3 {
  border-radius: 20px;
  border-color: rgba(148, 163, 184, 0.28);
  background: linear-gradient(
    180deg,
    rgba(255, 255, 255, 0.94),
    rgba(246, 250, 255, 0.94)
  );
  box-shadow: 0 10px 26px rgba(15, 23, 42, 0.08),
    inset 0 1px 0 rgba(255, 255, 255, 0.86);
}

.pa-mudik-page .pa-mudik-summary-card .v-list-item {
  min-height: 56px;
  padding: 0 20px;
}

.pa-mudik-page .pa-mudik-summary-card .v-list-item:first-child {
  min-height: 74px;
  background: linear-gradient(
    90deg,
    rgba(0, 31, 72, 0.1),
    rgba(0, 132, 147, 0.14)
  );
}

.pa-mudik-page .pa-mudik-summary-card .v-divider {
  border-color: #e6edf5;
}

.pa-mudik-page .pa-mudik-breakdown-list {
  padding-top: 0;
  padding-bottom: 0;
}

.pa-mudik-page .pa-mudik-breakdown-list .v-list-item-content {
  padding-right: 12px;
}

.pa-mudik-page .pa-mudik-breakdown-list .v-list-item-action {
  min-width: 140px;
  justify-content: flex-end;
  text-align: right;
  font-variant-numeric: tabular-nums;
}

.pa-mudik-page .pa-summary-total-label {
  letter-spacing: 2px;
  font-weight: 700;
  color: #0f172a;
  text-transform: uppercase;
}

.pa-mudik-page .pa-summary-total-value {
  letter-spacing: 0.6px;
  font-weight: 700;
  color: #0b3a70 !important;
  font-variant-numeric: tabular-nums;
}

.pa-mudik-page .pa-mudik-breakdown-list .v-list-item-subtitle {
  color: #334155;
  font-size: 15px;
}

.pa-mudik-page .pa-mudik-summary-card .v-list-item-action {
  font-size: 16px;
  font-weight: 700;
  color: #0f172a;
}

.pa-mudik-page
  .pa-mudik-summary-card
  .v-list-item:first-child
  .v-list-item-action {
  font-size: 30px;
  border-radius: 10px;
  border: 1px solid rgba(11, 58, 112, 0.18);
  padding: 5px 12px;
  background: rgba(255, 255, 255, 0.82);
}

.pa-mudik-page .pa-mudik-actions--step3 {
  margin-top: 20px;
  padding-top: 14px;
  border-top: 1px solid rgba(203, 213, 225, 0.8);
}

.pa-mudik-page .pa-mudik-actions {
  margin-top: 18px;
  display: flex;
  align-items: center;
  gap: 10px;
}

.pa-mudik-page .pa-mudik-actions--single .v-btn {
  width: 100%;
}

.pa-mudik-page .pa-mudik-btn-primary,
.pa-mudik-page .pa-mudik-btn-secondary,
.pa-mudik-page .pa-mudik-btn-accent,
.pa-mudik-page .pa-mudik-btn-ghost {
  border-radius: 999px !important;
  min-height: 42px;
  font-weight: 600;
  letter-spacing: 0.25px;
  text-transform: none;
}

.pa-mudik-page .pa-mudik-btn-primary {
  min-width: 148px;
  box-shadow: none !important;
  background: linear-gradient(
    135deg,
    var(--pa-primary),
    var(--pa-primary-dark)
  ) !important;
}

.pa-mudik-page .pa-mudik-btn-secondary {
  box-shadow: 0 8px 18px rgba(0, 132, 147, 0.26);
  background: linear-gradient(135deg, var(--pa-secondary), #0aa6b8) !important;
}

.pa-mudik-page .pa-mudik-btn-accent {
  box-shadow: 0 8px 18px rgba(62, 194, 209, 0.3);
  background: linear-gradient(
    135deg,
    var(--pa-secondary),
    var(--pa-accent)
  ) !important;
}

.pa-mudik-page .pa-mudik-btn-ghost {
  border: 1px solid var(--pa-border);
  color: #475569 !important;
  background: rgba(255, 255, 255, 0.75);
}

.pa-mudik-page .scrollable {
  max-height: 340px;
  overflow-y: auto;
}

.pa-mudik-page .spaus-upload-card {
  background: #f8fafc;
  border: 1px dashed #cbd5e1;
  border-radius: 12px;
}

.pa-mudik-page .spaus-upload-title {
  color: #0f172a;
  font-size: 16px;
  font-weight: 600;
}

.pa-mudik-page .spaus-upload-subtitle {
  color: #64748b;
  font-size: 12px;
  margin-top: 2px;
}

.pa-mudik-page .spaus-upload-placeholder {
  color: #94a3b8;
  font-size: 12px;
  margin-top: 8px;
}

.pa-mudik-page .spaus-upload-filename {
  color: #0f172a;
  font-size: 12px;
  margin-top: 8px;
  word-break: break-all;
}

.pa-mudik-page .spaus-upload-btn {
  letter-spacing: 0.6px;
  text-transform: uppercase;
  font-weight: 700;
}

.pa-mudik-page .spaus-upload-clear {
  margin-left: 4px;
}

.pa-mudik-page .pa-va-ramadan {
  border-radius: 18px;
  padding: 16px;
  border: 1px solid rgba(255, 205, 107, 0.5);
  background: radial-gradient(
      circle at top right,
      rgba(255, 211, 125, 0.35),
      transparent 48%
    ),
    radial-gradient(
      circle at left bottom,
      rgba(16, 185, 129, 0.18),
      transparent 45%
    ),
    linear-gradient(135deg, #0b2b4a, #0f766e 52%, #14532d);
  box-shadow: 0 14px 32px rgba(7, 26, 45, 0.26);
}

.pa-mudik-page .pa-va-ramadan__header {
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
}

.pa-mudik-page .pa-va-ramadan__badge {
  margin: 0 0 6px;
  display: inline-block;
  padding: 4px 10px;
  border-radius: 999px;
  color: #f8fafc;
  font-size: 11px;
  letter-spacing: 0.6px;
  text-transform: uppercase;
  background: rgba(15, 23, 42, 0.35);
}

.pa-mudik-page .pa-va-ramadan__title {
  margin: 0;
  color: #ffffff;
  font-size: 22px;
  font-weight: 700;
  letter-spacing: 0.3px;
}

.pa-mudik-page .pa-va-ramadan__register {
  color: #d1fae5;
  font-size: 13px;
  padding: 8px 12px;
  border-radius: 10px;
  border: 1px solid rgba(255, 255, 255, 0.24);
  background: rgba(2, 6, 23, 0.24);
}

.pa-mudik-page .pa-va-ramadan__list {
  margin-top: 14px;
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.pa-mudik-page .pa-va-ramadan__item {
  border-radius: 14px;
  padding: 12px;
  border: 1px solid rgba(255, 255, 255, 0.26);
  background: rgba(255, 255, 255, 0.9);
}

.pa-mudik-page .pa-va-ramadan__item-top {
  display: flex;
  justify-content: space-between;
  align-items: center;
  gap: 10px;
}

.pa-mudik-page .pa-va-ramadan__bank {
  display: inline-flex;
  align-items: center;
  gap: 6px;
  color: #0f172a;
  font-weight: 700;
  letter-spacing: 0.4px;
}

.pa-mudik-page .pa-va-ramadan__hint {
  font-size: 11px;
  color: #64748b;
}

.pa-mudik-page .pa-va-ramadan__number {
  margin-top: 10px;
  margin-bottom: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px dashed #94a3b8;
  background: #f8fafc;
  color: #0f172a;
  font-size: 19px;
  font-weight: 700;
  letter-spacing: 1.1px;
  font-variant-numeric: tabular-nums;
}

.pa-mudik-page .pa-va-ramadan__copy-btn {
  width: 100%;
  border-radius: 10px !important;
  text-transform: none;
  font-weight: 700;
  color: #0f172a !important;
  border: 1px solid #9ca3af;
  background: linear-gradient(135deg, #fef3c7, #fde68a) !important;
}

.pa-mudik-page .pa-va-ramadan__footer {
  margin-top: 14px;
  color: #ecfeff;
  font-size: 13px;
  border-top: 1px solid rgba(255, 255, 255, 0.28);
  padding-top: 12px;
}

.pa-mudik-page .pa-va-ramadan__status strong {
  margin-left: 4px;
  color: #fef3c7;
}

.pa-mudik-page .pa-va-ramadan__note {
  margin-top: 6px;
  color: #d1fae5;
}

.pa-mudik-loader-overlay {
  backdrop-filter: none;
  -webkit-backdrop-filter: none;
}

.pa-mudik-loader-card {
  width: min(92vw, 380px);
  border-radius: 18px;
  padding: 16px 16px 14px;
  border: 1px solid rgba(148, 163, 184, 0.34);
  background: linear-gradient(
    165deg,
    rgba(255, 255, 255, 0.98),
    rgba(241, 247, 253, 0.96)
  );
  box-shadow: 0 20px 45px rgba(2, 6, 23, 0.28);
}

.pa-mudik-loader-head {
  display: flex;
  align-items: center;
  gap: 12px;
}

.pa-mudik-loader-ring {
  width: 44px;
  height: 44px;
  border-radius: 50%;
  border: 3px solid rgba(148, 163, 184, 0.3);
  border-top-color: #0b6f8e;
  border-right-color: #1aaec3;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  animation: paMudikLoaderSpin 0.9s linear infinite;
}

.pa-mudik-loader-ring__core {
  width: 20px;
  height: 20px;
  border-radius: 50%;
  background: radial-gradient(
    circle,
    rgba(26, 174, 195, 0.35),
    rgba(11, 58, 112, 0.15)
  );
}

.pa-mudik-loader-copy {
  min-width: 0;
  flex: 1 1 auto;
}

.pa-mudik-loader-title {
  margin: 0;
  color: #0f172a;
  font-size: 16px;
  font-weight: 700;
  letter-spacing: 0.25px;
}

.pa-mudik-loader-subtitle {
  margin: 3px 0 0;
  color: #475569;
  font-size: 12px;
  line-height: 1.45;
}

.pa-mudik-loader-track {
  position: relative;
  overflow: hidden;
  margin-top: 12px;
  height: 6px;
  border-radius: 999px;
  background: rgba(148, 163, 184, 0.25);
}

.pa-mudik-loader-glow {
  position: absolute;
  top: 0;
  left: -42%;
  width: 42%;
  height: 100%;
  border-radius: inherit;
  background: linear-gradient(
    90deg,
    rgba(11, 58, 112, 0),
    rgba(11, 111, 142, 0.78),
    rgba(11, 58, 112, 0)
  );
  animation: paMudikLoaderSlide 1.15s ease-in-out infinite;
}

.pa-payment-dialog {
  border-radius: 20px !important;
  overflow: hidden;
}

.pa-payment-dialog__top {
  padding: 18px 20px;
  display: flex;
  justify-content: space-between;
  align-items: flex-start;
  gap: 12px;
  background: linear-gradient(135deg, #7c2d12, #ea580c 58%, #f59e0b);
}

.pa-payment-dialog__top--paid {
  background: linear-gradient(135deg, #0f766e, #0ea5a4 56%, #22c55e);
}

.pa-payment-dialog__hero {
  display: flex;
  gap: 12px;
  align-items: center;
}

.pa-payment-dialog__icon {
  width: 42px;
  height: 42px;
  border-radius: 50%;
  display: flex;
  align-items: center;
  justify-content: center;
  border: 1px solid rgba(255, 255, 255, 0.45);
  background: rgba(15, 23, 42, 0.24);
}

.pa-payment-dialog__status-chip {
  font-weight: 700;
  letter-spacing: 0.4px;
}

.pa-payment-dialog__kicker {
  margin: 0;
  color: rgba(255, 255, 255, 0.84);
  font-size: 12px;
  letter-spacing: 0.8px;
  text-transform: uppercase;
}

.pa-payment-dialog__title {
  margin: 4px 0 0;
  color: #ffffff;
  font-size: 20px;
  font-weight: 700;
}

.pa-payment-dialog__body {
  padding: 16px 18px 12px !important;
  background: #f8fafc;
}

.pa-payment-dialog__register {
  margin-bottom: 12px;
  color: #334155;
  font-size: 14px;
}

.pa-payment-dialog__steps {
  display: grid;
  grid-template-columns: repeat(3, minmax(0, 1fr));
  gap: 8px;
  margin-bottom: 12px;
}

.pa-payment-dialog__step {
  border-radius: 10px;
  border: 1px solid #dbe4ee;
  background: #ffffff;
  color: #64748b;
  font-size: 12px;
  font-weight: 600;
  min-height: 36px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  gap: 6px;
}

.pa-payment-dialog__step-dot {
  width: 18px;
  height: 18px;
  border-radius: 999px;
  display: inline-flex;
  align-items: center;
  justify-content: center;
  font-size: 11px;
  font-weight: 700;
  border: 1px solid #cbd5e1;
  color: #334155;
  background: #f8fafc;
}

.pa-payment-dialog__step--active {
  border-color: #f59e0b;
  color: #92400e;
  background: #fff7ed;
}

.pa-payment-dialog__step--active .pa-payment-dialog__step-dot {
  border-color: #f59e0b;
  color: #ffffff;
  background: #f59e0b;
}

.pa-payment-dialog__step--done {
  border-color: #10b981;
  color: #065f46;
  background: #ecfdf5;
}

.pa-payment-dialog__step--done .pa-payment-dialog__step-dot {
  border-color: #10b981;
  color: #ffffff;
  background: #10b981;
}

.pa-payment-dialog__grid {
  display: grid;
  grid-template-columns: repeat(2, minmax(0, 1fr));
  gap: 12px;
}

.pa-payment-dialog__item {
  border-radius: 12px;
  border: 1px solid #dbe4ee;
  background: #ffffff;
  padding: 12px;
}

.pa-payment-dialog__item-label {
  font-size: 12px;
  color: #64748b;
  text-transform: uppercase;
  letter-spacing: 0.8px;
}

.pa-payment-dialog__item-number {
  margin-top: 6px;
  margin-bottom: 10px;
  font-size: 19px;
  font-weight: 700;
  color: #0f172a;
  letter-spacing: 1px;
  font-variant-numeric: tabular-nums;
}

.pa-payment-dialog__copy {
  width: 100%;
  border-radius: 10px !important;
  text-transform: none;
  font-weight: 700;
  border: 1px solid #bfdbfe;
  color: #1e3a8a !important;
  background: linear-gradient(135deg, #eff6ff, #dbeafe) !important;
}

.pa-payment-dialog__note {
  margin-top: 12px;
  padding: 10px 12px;
  border-radius: 10px;
  border: 1px dashed #cbd5e1;
  background: #ffffff;
  color: #475569;
  font-size: 13px;
}

.pa-payment-dialog__actions {
  padding: 10px 16px 14px;
  background: #f8fafc;
}

.pa-family-dialog {
  border-radius: 20px !important;
  overflow: hidden;
  background: #f8fafc;
}

.pa-family-dialog__top {
  display: flex;
  align-items: flex-start;
  justify-content: space-between;
  gap: 10px;
  padding: 16px 18px;
  color: #ffffff;
  background: linear-gradient(135deg, #0b3a70 0%, #0b766f 100%);
}

.pa-family-dialog__kicker {
  margin: 0;
  font-size: 11px;
  font-weight: 700;
  letter-spacing: 1.2px;
  text-transform: uppercase;
  opacity: 0.9;
}

.pa-family-dialog__title {
  margin: 4px 0 2px;
  font-size: 20px;
  font-weight: 800;
  line-height: 1.2;
}

.pa-family-dialog__subtitle {
  margin: 0;
  font-size: 13px;
  opacity: 0.9;
}

.pa-family-dialog__close {
  margin-top: -2px;
  color: #ffffff !important;
}

.pa-family-dialog__body {
  padding: 16px 18px 8px !important;
}

.pa-family-dialog__body .v-input {
  margin-bottom: 2px;
}

.pa-family-dialog__actions {
  padding: 10px 14px 14px;
  background: #ffffff;
  border-top: 1px solid #e2e8f0;
}

@keyframes paMudikFadeIn {
  from {
    opacity: 0;
    transform: translateY(8px);
  }
  to {
    opacity: 1;
    transform: translateY(0);
  }
}

@media (max-width: 960px) {
  .pa-mudik-page {
    padding-left: 12px;
    padding-right: 12px;
  }

  .pa-mudik-page .pa-mudik-hero {
    margin-top: 10px;
    border-radius: 16px;
    padding: 22px 18px 20px;
  }

  .pa-mudik-page .pa-mudik-hero__title {
    font-size: 24px;
  }

  .pa-mudik-page .pa-mudik-step-content {
    padding: 18px 16px 20px;
  }

  .pa-mudik-page .pa-mudik-form-shell {
    padding: 0 12px;
  }

  .pa-mudik-page .pa-mudik-step4-shell {
    padding-left: 14px;
    padding-right: 14px;
  }

  .pa-mudik-page .pa-mudik-step3-shell {
    padding: 6px 16px 8px;
  }

  .pa-mudik-page .pa-mudik-grid > .flex {
    padding-left: 8px;
    padding-right: 8px;
  }

  .pa-mudik-page .pa-mudik-period-day-col {
    max-width: none;
  }

  .pa-mudik-page .pa-mudik-stepper .v-stepper__header {
    border-radius: 12px;
  }

  .pa-mudik-page .pa-mudik-restore__card {
    align-items: flex-start;
    flex-direction: column;
  }

  .pa-mudik-page .pa-mudik-restore__search-form {
    width: 100%;
    flex-direction: column;
    align-items: stretch;
  }

  .pa-mudik-page .pa-mudik-section-head__title {
    font-size: 21px;
  }

  .pa-mudik-page .pa-mudik-step1-grid > .col {
    padding-top: 4px;
    padding-bottom: 4px;
  }
}

@keyframes paMudikLoaderSpin {
  to {
    transform: rotate(360deg);
  }
}

@keyframes paMudikLoaderSlide {
  to {
    left: 100%;
  }
}

@media (max-width: 600px) {
  .pa-mudik-page {
    padding-left: 10px;
    padding-right: 10px;
  }

  .pa-mudik-page .pa-mudik-hero__chips {
    gap: 8px;
  }

  .pa-mudik-page .pa-mudik-chip {
    font-size: 12px;
  }

  .pa-mudik-page .pa-mudik-btn-primary,
  .pa-mudik-page .pa-mudik-btn-secondary,
  .pa-mudik-page .pa-mudik-btn-accent,
  .pa-mudik-page .pa-mudik-btn-ghost {
    width: auto;
    margin-bottom: 0;
  }

  .pa-mudik-page .pa-mudik-total-spotlight__value {
    font-size: 30px;
  }

  .pa-mudik-page .pa-mudik-total-spotlight--step3 {
    border-radius: 20px;
    padding: 20px 22px;
  }

  .pa-mudik-page .pa-mudik-form-shell {
    padding: 0 12px;
  }

  .pa-mudik-page .pa-mudik-step4-shell {
    padding-left: 14px;
    padding-right: 14px;
  }

  .pa-mudik-page .pa-mudik-step3-shell {
    padding: 6px 16px 8px;
  }

  .pa-mudik-page .pa-mudik-field-label {
    margin-bottom: 10px;
    font-size: 13px;
  }

  .pa-mudik-page .pa-mudik-package-pills .v-input--radio-group__input {
    gap: 10px;
  }

  .pa-mudik-page .pa-mudik-package-pills .v-label {
    min-width: 88px;
    padding: 8px 14px;
    font-size: 14px;
  }

  .pa-mudik-page .pa-mudik-period-day-input input {
    font-size: 18px;
  }

  .pa-mudik-page .pa-mudik-summary-card .v-list-item {
    min-height: 56px;
    padding: 0 20px;
  }

  .pa-mudik-page .pa-mudik-summary-card .v-list-item:first-child {
    min-height: 74px;
  }

  .pa-mudik-page .pa-mudik-summary-card .v-list-item-action {
    font-size: 16px;
  }

  .pa-mudik-page
    .pa-mudik-summary-card
    .v-list-item:first-child
    .v-list-item-action {
    font-size: 30px;
  }

  .pa-mudik-page .pa-summary-total-label {
    letter-spacing: 2px;
  }

  .pa-mudik-page .pa-va-ramadan {
    padding: 14px;
  }

  .pa-mudik-page .pa-va-ramadan__header {
    flex-direction: row;
  }

  .pa-mudik-page .pa-va-ramadan__register {
    width: auto;
  }

  .pa-mudik-page .pa-va-ramadan__list {
    grid-template-columns: repeat(2, minmax(0, 1fr));
  }

  .pa-mudik-page .pa-va-ramadan__title {
    font-size: 22px;
  }

  .pa-mudik-loader-card {
    width: min(94vw, 360px);
    border-radius: 16px;
    padding: 14px 14px 12px;
  }

  .pa-mudik-loader-title {
    font-size: 15px;
  }

  .pa-mudik-loader-subtitle {
    font-size: 11px;
  }

  .pa-payment-dialog__item-number {
    font-size: 19px;
  }

  .pa-family-dialog__title {
    font-size: 20px;
  }

  .pa-family-dialog__body {
    padding: 14px 12px 6px !important;
  }

  .pa-family-dialog__actions {
    flex-wrap: wrap;
    gap: 8px;
  }
}
</style>
